webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4061c7f6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(341)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4061c7f6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4061c7f6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageSource_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acd6914_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageSource_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(356)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageSource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acd6914_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageSource_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acd6914_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageSource_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var sanityClient = __webpack_require__(30);

var client = sanityClient({
  projectId: '6usbttwh',
  dataset: 'production_new',
  useCdn: true
});

var sanityQuery = function sanityQuery(query) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    client.fetch(query).then(function (result) {
      resolve(result);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (sanityQuery);

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonCard_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785f2ae8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonCard_vue__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(364)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785f2ae8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_785f2ae8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_BecomeMember__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_MainPage__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_FrontPage__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_FourOFour__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Partiet__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Politikken__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_resource__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_meta__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_meta___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/404',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_FourOFour__["a" /* default */]
  }, {
    path: '/',
    name: 'FrontPage',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_FrontPage__["a" /* default */],
    meta: {
      keepAlive: true
    }
  }, {
    path: '/organisasjonen',
    name: 'Organisasjonen',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Partiet__["a" /* default */],
    meta: {
      keepAlive: true
    }
  }, {
    path: '/politikken',
    name: 'Politikken',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Politikken__["a" /* default */],
    meta: {
      keepAlive: true
    }
  }, {
    path: '/bli-medlem',
    name: 'BecomeMember',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_BecomeMember__["a" /* default */]
  }, {
    path: '/:slug',
    name: 'MainPage',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_MainPage__["a" /* default */]
  }, {
    path: '/*',
    redirect: {
      name: '404'
    }
  }],
  mode: 'history',
  saveScrollPosition: true,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
}));

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CampaignFrontpageTop__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CampaignSquare__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CampaignMedium__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CampaignNoPic__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_CampaignNoText__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ChapterDropdown__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DocumentRef__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Donate__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FrontpageIssueList__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IssueSearch__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_IssueList__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_GoogleFormBlock__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Group__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_HeroJerkBlock__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ImageBlock__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_LinksBlock__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_NewsList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_PersonCard__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_TextBlock__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_PersonSearch__ = __webpack_require__(455);






















var BlockRender = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('block-render', {
  functional: true,
  render: function render(createElement, context) {
    var blocks = context.props.blocks;
    var elements = [];
    var textBlocks = [];

    blocks.forEach(function (block, index) {
      var next = blocks[index + 1];

      switch (block._type) {
        case 'block':
          if (!next || next._type !== 'block') {
            textBlocks.push(block);
            elements.push(createElement(__WEBPACK_IMPORTED_MODULE_19__components_TextBlock__["a" /* default */], {
              props: {
                blocks: textBlocks,
                wrapClasses: context.props.textWrapClasses
              }
            }));
            textBlocks = [];
          } else {
            textBlocks.push(block);
          }
          break;

        case 'documentRef':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_7__components_DocumentRef__["a" /* default */], {
            props: {
              document: block.document,
              wrapClasses: context.props.textWrapClasses
            }
          }));
          break;

        case 'donate':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_8__components_Donate__["a" /* default */], {
            props: {
              text: block.text
            }
          }));
          break;

        case 'personBlock':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_18__components_PersonCard__["a" /* default */], {
            props: {
              role: block.role,
              person: block.person,
              wrap: 'column is-8 is-7-widescreen is-offset-2 is-paddingless-mobile'
            }
          }));
          break;

        case 'campaign_frontpage_top':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_1__components_CampaignFrontpageTop__["a" /* default */], {
            props: {
              text: block.text,
              link: block.link_to,
              linkText: block.link_text,
              imageUrl: block.image
            }
          }));
          break;

        case 'campaign':
          switch (block.viewType) {
            case 'Medium':
              elements.push(createElement(__WEBPACK_IMPORTED_MODULE_3__components_CampaignMedium__["a" /* default */], {
                props: {
                  text: block.title,
                  link: block.link,
                  linkText: block.title,
                  imageUrl: block.image.asset.url,
                  ctaText: block.cta
                }
              }));
              break;

            case 'Kvadrat':
              elements.push(createElement(__WEBPACK_IMPORTED_MODULE_2__components_CampaignSquare__["a" /* default */], {
                props: {
                  text: block.title,
                  link: block.link,
                  linkText: block.title,
                  imageUrl: block.image.asset.url,
                  ctaText: block.cta
                }
              }));
              break;

            case 'Kun bilde':
              elements.push(createElement(__WEBPACK_IMPORTED_MODULE_5__components_CampaignNoText__["a" /* default */], {
                props: {
                  link: block.link,
                  imageUrl: block.image.asset.url
                }
              }));
              break;

            case 'Kun tekst':
              elements.push(createElement(__WEBPACK_IMPORTED_MODULE_4__components_CampaignNoPic__["a" /* default */], {
                props: {
                  link: block.link,
                  text: block.title,
                  ctaText: block.cta
                }
              }));
              break;
          }
          break;

        case 'googleForm':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_12__components_GoogleFormBlock__["a" /* default */], {
            props: {
              url: block.url
            }
          }));
          break;

        case 'group':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_13__components_Group__["a" /* default */], {
            props: {
              title: block.title,
              members: block.members
            }
          }));
          break;

        case 'heroJerkBlock':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_14__components_HeroJerkBlock__["a" /* default */], {
            props: {
              hero: block.hero,
              jerk: block.jerk
            }
          }));
          break;

        case 'frontPageIssueList':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_9__components_FrontpageIssueList__["a" /* default */], {
            props: {
              issues: block.frontPageIssues
            }
          }));
          break;

        case 'issueList':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_11__components_IssueList__["a" /* default */]));
          break;

        case 'issueSearchBlock':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_10__components_IssueSearch__["a" /* default */]));
          break;

        case 'linksBlock':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_16__components_LinksBlock__["a" /* default */], {
            props: {
              links: block.links
            }
          }));
          break;

        case 'lagFinderBlock':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_6__components_ChapterDropdown__["a" /* default */], {
            props: {
              title: block.title
            }
          }));
          break;

        case 'personSearchBlock':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_20__components_PersonSearch__["a" /* default */], {
            props: {
              title: block.title
            }
          }));
          break;

        case 'newsBlock':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_17__components_NewsList__["a" /* default */]));
          break;

        case 'rodtImage':
          elements.push(createElement(__WEBPACK_IMPORTED_MODULE_15__components_ImageBlock__["a" /* default */], {
            props: {
              caption: block.caption,
              imageUrl: block.image.asset.url,
              size: block.imageSize
            }
          }));
          break;
      }
    });
    return createElement('div', { style: { width: '100%' } }, elements);
  },
  props: {
    textWrapClasses: String,
    blocks: {
      type: Array
    },
    isOrdered: Boolean
  },
  name: 'blockrender'
});

/* harmony default export */ __webpack_exports__["a"] = (BlockRender);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(439);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'navbar': __WEBPACK_IMPORTED_MODULE_0__components_Navbar__["a" /* default */],
    'foot': __WEBPACK_IMPORTED_MODULE_1__components_Footer__["a" /* default */]
  },
  name: 'app'
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text', 'link', 'linkText', 'imageUrl'],
  data: function data() {
    return {
      imageStyle: {
        backgroundImage: 'url(' + this.imageUrl + '?w=1400&h=1100&q=60)'
      },
      onclick: 'window.open(\'' + this.link + '\',\'_self\')'
    };
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'image-source': __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__["a" /* default */]
  },
  props: ['text', 'link', 'linkText', 'imageUrl', 'ctaText'],
  data: function data() {
    return {
      'widths': [530, 800, 1400],
      'width': null
    };
  },
  mounted: function mounted() {
    this.width = this.$refs.imageContainer.clientWidth;
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text', 'ctaText', 'link']
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'image-source': __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__["a" /* default */]
  },
  props: ['link', 'imageUrl'],
  data: function data() {
    return {
      'widths': [600, 800, 1100],
      width: null
    };
  },
  mounted: function mounted() {
    this.width = this.$refs.imageContainer.clientWidth;
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'image-source': __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__["a" /* default */]
  },
  props: ['text', 'link', 'linkText', 'imageUrl', 'ctaText'],
  data: function data() {
    return {
      'widths': [600, 800, 1100],
      'width': null
    };
  },
  mounted: function mounted() {
    this.width = this.$refs.imageContainer.clientWidth;
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_chevron_down__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sanityQuery__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },
  data: function data() {
    return {
      chapters: [],
      showDropdown: false
    };
  },
  created: function created() {
    var _this = this;

    var query = '*[_type == "lag" && !(_id in path "drafts.**")] | order(title asc)  [0...200]{title, slug,  "county": county->{..., title, slug}}';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sanityQuery__["a" /* default */])(query).then(function (result) {
      var chapters = result;
      var returnChapters = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(chapters), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var chapter = _step.value;

          if (!chapter.county) {
            returnChapters.push(chapter);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(chapters), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _chapter = _step2.value;

                if (_chapter.county) {
                  if (_chapter.county.title === chapter.title) {
                    returnChapters.push(_chapter);
                  }
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _this.chapters = returnChapters;
    });
  },

  methods: {
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      console.log(this.showDropdown);
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_file_text_o__ = __webpack_require__(429);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['document', 'wrapClasses'],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stripeConfig_json__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stripeConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stripeConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_nb_NO__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_nb_NO___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_nb_NO__);





__webpack_require__(113).polyfill();
__webpack_require__(114);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Card: __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__["Card"] },
  created: function created() {
    this.$http.options.xhr = { withCredentials: true };
    this.$http.options = { credentials: true };
    this.$http.options.emulateJSON = true;
    this.$validator.updateDictionary({
      nb_NO: {
        messages: __WEBPACK_IMPORTED_MODULE_2_vee_validate_dist_locale_nb_NO___default.a.messages
      }
    });
    this.$validator.setLocale('nb_NO');
  },
  data: function data() {
    return {
      key: __WEBPACK_IMPORTED_MODULE_0__stripeConfig_json__["stripeKey"],
      options: __WEBPACK_IMPORTED_MODULE_0__stripeConfig_json__["stripeOptions"],
      cardComplete: false,
      showForm: false,
      cardError: null,
      formIsValid: false,
      formIsLoading: false,
      formData: {
        stripeAmount: 0,
        userEmail: '',
        zip: '',
        navn: '',
        stripeToken: ''
      },
      formDetails: {
        display: 'none'
      }
    };
  },

  props: ['text', 'sub'],
  methods: {
    pay: function pay() {
      var _this = this;

      this.formIsLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements__["createToken"])({
        name: this.formData.navn,
        email: this.formData.userEmail,
        address_zip: this.formData.zip
      }).then(function (data) {
        console.log(data);
        if (data.error) {
          _this.formIsLoading = false;
          _this.formIsValid = false;
          _this.cardError = data.error.message;
        } else {
          _this.formData.stripeAmount = _this.formData.stripeAmount * 100;
          _this.formData.stripeToken = data.token.id;
          var submitData = new FormData();
          submitData.append('userEmail', _this.formData.userEmail);
          submitData.append('stripeToken', _this.formData.stripeToken);
          submitData.append('navn', _this.formData.navn);
          submitData.append('stripeAmount', _this.formData.stripeAmount);
          console.log(submitData);
          fetch('https://peaceful-cliffs-83180.herokuapp.com/doner', {
            body: submitData,
            method: 'POST'
          }).then(function (result) {
            console.log(result);
          });
        }
      });
    },
    cardUpdate: function cardUpdate(event) {
      console.log(event);
      if (event.error) {
        this.cardError = event.error.message;
      } else {
        this.cardError = null;
        this.validateForm();
        if (event.complete && this.formIsValid) {
          this.cardComplete = true;
        } else {
          this.cardComplete = false;
        }
      }
    },
    buttonClick: function buttonClick(amount) {
      this.showForm = true;
      this.formDetails.display = 'block';
      this.formData.stripeAmount = amount;
    },
    validateForm: function validateForm() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.formIsValid = true;
      }).catch(function () {
        _this2.formIsValid = false;
      });
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_facebook_official__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_instagram__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_twitter__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_flickr__ = __webpack_require__(430);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */]
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title', 'slug', 'image', 'lead'],
  components: {
    'image-source': __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__["a" /* default */]
  },
  data: function data() {
    return {
      widths: [600, 600, 800]
    };
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_IssueCard__ = __webpack_require__(448);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'issue-card': __WEBPACK_IMPORTED_MODULE_0__components_IssueCard__["a" /* default */]
  },
  data: function data() {
    return {
      i: this.issues
    };
  },

  props: ['issues']
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['url']
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PersonCard__ = __webpack_require__(29);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'person-card': __WEBPACK_IMPORTED_MODULE_0__components_PersonCard__["a" /* default */]
  },
  props: ['title', 'members'],
  created: function created() {}
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons_chevron_down__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_chevron_up__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImageSource__ = __webpack_require__(6);







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['hero', 'jerk'],
  name: 'hero-jerk-block',
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_0_vue_awesome_components_Icon__["a" /* default */],
    ImageSource: __WEBPACK_IMPORTED_MODULE_3__components_ImageSource__["a" /* default */]
  },
  data: function data() {
    return {
      displayHeroText: false,
      displayJerkText: false,
      widths: ['500', '500', '500'],
      width: null
    };
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hero-text'
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'image-source': __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__["a" /* default */]
  },
  props: ['size', 'caption', 'imageUrl'],
  data: function data() {
    return {
      smallWidths: [700, 700, 700],
      mediumWidths: [700, 1500, 2000],
      bigWidths: [700, 2000, 2400],
      metaContentUrl: this.imageUrl + '?w=2000&h=#{1360/1.78}',
      width: null
    };
  },
  mounted: function mounted() {
    this.width = this.$refs.imageContainer.clientWidth;
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-source',
  data: function data() {
    return {
      srcset: null,
      styles: '',
      widths: [500, 1000, 1500, 2000]
    };
  },

  props: ['source', 'ratio', 'alt', 'params', 'metadata', 'width', 'fit', 'chapterUrlBuilder', 'transparent'],
  watch: {
    'source': function source() {
      window.lazySizes.loader.unveil(this.$refs.imageEl);
    }
  },
  computed: {
    containerStyle: function containerStyle() {
      return {
        'paddingBottom': 1 / this.ratio * 100 + '%',
        'backgroundImage': !this.transparent && 'url(' + this.imageUrl.image(this.source).width(100).height(parseInt(100 / this.ratio)).blur(80).url() + ')'
      };
    },
    imageUrl: function imageUrl() {
      return this.chapterUrlBuilder ? this.$chapterSanityUrl : this.$sanityImageUrl;
    },

    lqip: function lqip() {
      var lqip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["get"])(this.source, 'asset.metadata.lqip');
      var fit = this.fit || 'crop';

      return lqip || this.imageUrl.image(this.source).width(100).height(parseInt(100 * this.ratio, 10)).fit(fit).format(this.transparent ? 'png' : 'jpg').quality(80).url();
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BlockRender__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ImageSource__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sanityQuery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loader__ = __webpack_require__(247);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'issue-article',
  props: ['article'],
  components: {
    'blockrender': __WEBPACK_IMPORTED_MODULE_0__components_BlockRender__["a" /* default */],
    ImageSource: __WEBPACK_IMPORTED_MODULE_1__components_ImageSource__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_3__components_Loader__["a" /* default */]
  },
  data: function data() {
    return {
      mediumWidths: [700, 1500, 2000],
      relatedIssues: null,
      classes: 'column'
    };
  },
  created: function created() {
    var _this = this;

    var query = '*[_type == "issue" && category == "' + this.article.category + '" && slug.current != "' + this.article.slug.current + '"]{title, slug, "redirect": redirect->{title, slug}}';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sanityQuery__["a" /* default */])(query).then(function (result) {
      _this.relatedIssues = result;
    });
  },

  computed: {
    shareUrl: function shareUrl() {
      return 'https://www.facebook.com/dialog/share?app_id=520751354930010&display=popup&href=https://r\xF8dungdom.no' + this.$route.path + '&redirect_uri=https://r\xF8dungdom.no' + this.$route.path;
    }
  },
  methods: {
    getSlug: function getSlug(issue) {
      if (issue.redirect) {
        return issue.redirect.slug.current;
      } else {
        return issue.slug.current;
      }
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.article.title + ' \u2014 R\xF8d Ungdom',
      htmlAttrs: {
        lang: 'no',
        amp: undefined },
      meta: [{ name: 'title', content: this.article.title + ' \u2014 R\xF8d Ungdom' }, { name: 'description', content: this.article.lead }, { name: 'twitter:title', content: this.article.title + ' \u2014 R\xF8d Ungdom' }, { name: 'twitter:description', content: this.article.lead }, { name: 'twitter:image', content: '' + (this.article.headerImage ? this.article.headerImage.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png') }, { property: 'og:title', content: this.article.title + ' \u2014 R\xF8d Ungdom' }, { property: 'og:description', content: this.article.lead }, { property: 'og:image', content: '' + (this.article.headerImage ? this.article.headerImage.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png') }, { property: 'og:url', content: 'http://xn--rdungdom-54a.no' + this.$route.path }]
    };
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      widths: [800, 800, 800],
      slug: ''
    };
  },

  components: {
    'image-source': __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__["a" /* default */]
  },
  props: ['issue']
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sanityQuery__ = __webpack_require__(7);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      issuesByLetter: []
    };
  },
  created: function created() {
    var _this = this;

    var query = '*[_type == "issue" && !(_id in path "drafts.**")][0...500] | order(title asc){title, slug{current}, "redirect": redirect->{title, slug}}';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanityQuery__["a" /* default */])(query).then(function (result) {
      var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWZÆØÅ'.split('');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(alphabet), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var letter = _step.value;

          var letterObj = {};
          letterObj.issues = [];
          letterObj.letter = letter;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var issue = _step2.value;

              if (issue.title.charAt(0) === letter) {
                letterObj.issues.push(issue);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          _this.issuesByLetter.push(letterObj);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });
  },

  methods: {
    getSlug: function getSlug(issue) {
      if (issue.redirect) {
        return issue.redirect.slug.current;
      } else {
        return issue.slug.current;
      }
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sanityQuery__ = __webpack_require__(7);




__webpack_require__(283);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Forsiden',
      term: '',
      foundIssues: [],
      inputFocus: true
    };
  },
  mounted: function mounted() {
    this.getPlaceholderIssues();
  },

  watch: {
    term: function term(_term) {
      var _this = this;

      if (_term !== '') {
        var query = '*[_type == "issue" && title match [' + _term.split(/\s+/).map(function (s) {
          return '"' + s + '*"';
        }) + ']] | order(name) [0...500]{title, slug}';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sanityQuery__["a" /* default */])(query).then(function (result) {
          _this.foundIssues = result;
        });
      } else {
        this.foundIssues = [];
      }
    }
  },
  methods: {
    getPlaceholderIssues: function getPlaceholderIssues() {
      var query = '*[_type == "issue" && !(_id in path "drafts.**")][0...500] | order(title asc){title}';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sanityQuery__["a" /* default */])(query).then(function (result) {
        var placeholders = [];
        result.map(function (i) {
          return placeholders.push(i.title);
        });
        window.Typed.new('#Typed', {
          strings: placeholders,
          typeSpeed: 20,
          attr: 'placeholder',
          shuffle: true,
          loop: true,
          showCursor: true,
          backDelay: 2000
        });
      });
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {},
  props: ['link']
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LinkCard__ = __webpack_require__(451);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'link-card': __WEBPACK_IMPORTED_MODULE_0__components_LinkCard__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  props: ['links'],
  methods: {
    isEven: function isEven(n) {
      return n % 2 === 0;
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(249);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loader',
  components: {
    PulseLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_PulseLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      spinnerColor: '#f0f0f0'
    };
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar'
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BlockRender__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loader__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ImageSource__ = __webpack_require__(6);







__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('nb');

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['article'],
  data: function data() {
    return {
      classes: 'column is-8 is-7-widescreen is-offset-2',
      title: this.article.title,
      relatedIssues: this.article.related_issues,
      widths: [530, 800, 1400],
      width: null
    };
  },
  mounted: function mounted() {
    this.width = this.$refs.imageContainer.clientWidth;
  },

  components: {
    'blockrender': __WEBPACK_IMPORTED_MODULE_0__components_BlockRender__["a" /* default */],
    Loader: __WEBPACK_IMPORTED_MODULE_2__components_Loader__["a" /* default */],
    ImageSource: __WEBPACK_IMPORTED_MODULE_3__components_ImageSource__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {},

  methods: {
    convertDate: function convertDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('Do MMMM YYYY H:mm');
    },
    getSlug: function getSlug(issue) {
      if (issue.redirect) {
        return issue.redirect.slug.current;
      } else {
        return issue.slug.current;
      }
    }
  },
  computed: {
    shareUrl: function shareUrl() {
      return 'https://www.facebook.com/dialog/share?app_id=520751354930010&display=popup&href=https://r\xF8dungdom.no' + this.$route.path + '&redirect_uri=https://r\xF8dungdom.no' + this.$route.path;
    },
    setBackgroundImage: function setBackgroundImage() {
      if (this.article.thumbnail) {
        return {
          backgroundImage: 'url(' + this.article.thumbnail.asset.url + '?w=2000&q=60&blur=30)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center'
        };
      } else {
        return null;
      }
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.article.title + ' \u2014 R\xF8d Ungdom',
      htmlAttrs: {
        lang: 'no',
        amp: undefined },
      meta: [{ name: 'title', content: this.article.title + ' \u2014 R\xF8d Ungdom' }, { name: 'description', content: this.article.lead }, { name: 'twitter:title', content: this.article.title + ' \u2014 R\xF8d Ungdom' }, { name: 'twitter:description', content: this.article.lead || 'Vi organiserer ungdom til kamp for en rettferdig verden.' }, { name: 'twitter:image', content: '' + (this.article.thumbnail ? this.article.thumbnail.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png') }, { property: 'og:title', content: this.article.title + ' \u2014 R\xF8d Ungdom' }, { property: 'og:description', content: this.article.lead || 'Vi organiserer ungdom til kamp for en rettferdig verden.' }, { property: 'og:image', content: '' + (this.article.thumbnail ? this.article.thumbnail.asset.url + '?w=1200&h=630&fit=crop' : 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png') }, { property: 'og:url', content: 'http://xn--rdungdom-54a.no' + this.$route.path }]
    };
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sanityQuery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FrontPageNewsItem__ = __webpack_require__(440);





var sliceStart = 0;
var sliceStop = 3;
var query = '*[_type == "article" && !(_id in path "drafts.**")]{title, lead, slug, "thumbnail": thumbnail{crop, hotspot, "asset": asset->{url, metadata}}, "publishDate": coalesce(publishedAt.local, _createdAt)} | order(publishDate desc) | [' + sliceStart + '...' + sliceStop + ']';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewsList',
  components: {
    'news-item': __WEBPACK_IMPORTED_MODULE_1__components_FrontPageNewsItem__["a" /* default */]
  },
  data: function data() {
    return {
      'newsItems': null,
      'isLoading': false
    };
  },
  created: function created() {
    this.loadArticles();
  },

  methods: {
    loadArticles: function loadArticles() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sanityQuery__["a" /* default */])(query).then(function (result) {
        _this.newsItems = result;
      });
    },
    generateSlug: function generateSlug(slug) {
      return '/' + slug;
    },
    loadMoreArticles: function loadMoreArticles() {
      var _this2 = this;

      sliceStop += 3;
      this.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sanityQuery__["a" /* default */])('*[_type == "article" && !(_id in path "drafts.**")]{title, lead, slug, "thumbnail": thumbnail{crop, hotspot, "asset": asset->{url, metadata}}, "publishDate": coalesce(publishedAt.local, _createdAt)} | order(publishDate desc) | [' + sliceStart + '...' + sliceStop + ']').then(function (result) {
        _this2.newsItems = result;
        _this2.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons_envelope_o__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_facebook_official__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_instagram__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_twitter__ = __webpack_require__(246);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'person-card',
  components: {
    'image-source': __WEBPACK_IMPORTED_MODULE_0__components_ImageSource__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon__["a" /* default */]
  },
  props: ['person', 'role', 'wrap'],
  methods: {
    imageUrl: function imageUrl(url) {
      return url + '?w=200&h=200';
    },
    phoneLink: function phoneLink(number) {
      return 'tel:' + number;
    },
    mailTo: function mailTo(mail) {
      return 'mailto:' + mail;
    },
    twitterLink: function twitterLink(handle) {
      return 'https://twitter.com/' + handle.replace('@', '');
    },
    instagramLink: function instagramLink(handle) {
      return 'https://instagram.com/' + handle.replace('@', '');
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PersonCard__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sanityQuery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(249);






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  components: {
    'person-card': __WEBPACK_IMPORTED_MODULE_0__components_PersonCard__["a" /* default */],
    PulseLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      term: '',
      foundPeople: [],
      inputFocus: true,
      delayedSearch: null,
      searched: false,
      searching: true
    };
  },

  watch: {
    term: function term(_term) {
      this.searched = false;
      if (_term !== '') {
        clearTimeout(this.delayedSearch);
        this.delayedSearch = setTimeout(this.sanitySearch, 500);
      } else {
        this.foundPeople = [];
      }
    }
  },
  methods: {
    sanitySearch: function sanitySearch() {
      var _this = this;

      if (this.term.split('').length > 0) {
        this.searching = true;
        var query = '*[_type == "person" && name match [' + this.term.toLowerCase().split(/\s+/).map(function (s) {
          return '"' + s + '*"';
        }) + ']] | order(name) [0...5000]{\n          _id, name, email, phone, twitter, facebook, instagram, \n          profile_image{..., asset->}}';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanityQuery__["a" /* default */])(query).then(function (result) {
          _this.searching = false;
          _this.searched = true;
          if (result.length > 0) {
            _this.foundPeople = result;
          }
        });
      } else {
        this.foundPeople = [];
      }
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__renderBlocks__ = __webpack_require__(286);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rawhtml: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__renderBlocks__["a" /* default */])(this.blocks)
    };
  },

  props: ['blocks', 'wrapClasses']
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate_dist_locale_nb_NO__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vee_validate_dist_locale_nb_NO___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vee_validate_dist_locale_nb_NO__);



__webpack_require__(113).polyfill();
__webpack_require__(114);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'R\xF8d Ungdom \u2014 Bli medlem!',
      htmlAttrs: {
        lang: 'no',
        amp: undefined },
      meta: [{ name: 'title', content: 'R\xF8d Ungdom \u2014 Bli medlem!' }, { name: 'description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!' }, { name: 'twitter:title', content: 'R\xF8d Ungdom \u2014 Bli medlem!' }, { name: 'twitter:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!' }, { name: 'twitter:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png' }, { property: 'og:title', content: 'R\xF8d Ungdom \u2014 Bli medlem!' }, { property: 'og:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!' }, { property: 'og:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png' }, { property: 'og:url', content: 'https://xn--rdungdom-54a.no' + this.$route.path }]
    };
  },
  created: function created() {
    this.$validator.localize('nb_NO', {
      messages: __WEBPACK_IMPORTED_MODULE_0_vee_validate_dist_locale_nb_NO___default.a.messages
    });
    this.$validator.localize('nb_NO');
  },

  methods: {
    validateForm: function validateForm() {
      var _this = this;

      this.isLoading = true;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.submitForm();
        } else {
          _this.formIsValid = false;
          _this.isLoading = false;
        }
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;

      var data = new FormData(this.$refs.memberForm);
      fetch(this.$refs.memberForm.action, {
        body: data,
        method: 'POST'
      }).then(function (result) {
        if (result.status === 200) {
          _this2.$router.push('/velkommen');
        }
      });
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PersonCard__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sanityQuery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons_facebook_official__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NewsList__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ImageSource__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'person-card': __WEBPACK_IMPORTED_MODULE_0__components_PersonCard__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon__["a" /* default */],
    NewsList: __WEBPACK_IMPORTED_MODULE_4__components_NewsList__["a" /* default */],
    ImageSource: __WEBPACK_IMPORTED_MODULE_5__components_ImageSource__["a" /* default */]
  },
  props: ['data'],
  data: function data() {
    return {
      chapters: [],
      selected: 'Velg lokallag',
      articles: [],
      widths: [600, 800, 1200]
    };
  },

  watch: {
    selected: function selected(_selected) {
      this.$router.push({ path: _selected });
    },

    data: function data() {
      this.getLocalChapters();
    }
  },
  created: function created() {
    this.getLocalChapters();
  },

  methods: {
    getLocalChapters: function getLocalChapters() {
      var _this = this;

      var query = '*[_type == "lag" && references("' + this.data._id + '") && !(_id in path "drafts.**")] | order(title asc) [0...200]{title, slug}';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sanityQuery__["a" /* default */])(query).then(function (result) {
        _this.chapters = result;
      });
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sanityQuery__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      content: null
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: 'Rød Ungdom',
      htmlAttrs: {
        lang: 'no',
        amp: undefined },
      meta: [{ name: 'title', content: 'Rød Ungdom' }, { name: 'description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!' }, { name: 'twitter:title', content: 'Rød Ungdom' }, { name: 'twitter:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!' }, { name: 'twitter:image', content: 'https://xn--rdt-0na.no/images/standard_delebilde_fb.png' }, { property: 'og:title', content: 'Rød Ungdom' }, { property: 'og:description', content: 'Rød Ungdom er ungdomspartiet til Rødt. Vi organiserer ungdom til kamp for et rettferdig verden. Folkestyre over pengestyre – det handler om å velge side!' }, { property: 'og:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png' }, { property: 'og:url', content: 'https://xn--rdungdom-54a.no' + this.$route.path }]
    };
  },
  created: function created() {
    var _this = this;

    var query = '*[_id == "489f4f54-e073-4896-af2b-1ee728ce3665" && !(_id in path "drafts.**")]\n    {\n      "blocks": blocks {\n        "content": content[] {\n          ...,\n          "hero": hero {\n            ...,\n            "image": image {\n              ...,\n              "asset": asset->{url, metadata}\n            }\n          },\n          "jerk": jerk {\n            ...,\n            "image": image {\n              ...,\n              "asset": asset->{url, metadata}\n            }\n          },\n          "frontPageIssues": frontPageIssues[] {\n            lead,\n            "issue": frontPageIssue-> {\n              title,\n              slug,\n              "image": image {\n                ...,\n                "asset": asset->{url, metadata}\n              }\n            }\n          },\n          "image": image{"asset": asset->{url, metadata}}\n        }\n      }\n    }';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sanityQuery__["a" /* default */])(query).then(function (result) {
      _this.content = result[0].blocks.content;
    });
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getSanityDocument__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_NewsArticle__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Chapter__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IssueArticle__ = __webpack_require__(447);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'newsarticle': __WEBPACK_IMPORTED_MODULE_2__components_NewsArticle__["a" /* default */],
    'chapter': __WEBPACK_IMPORTED_MODULE_3__pages_Chapter__["a" /* default */],
    IssueArticle: __WEBPACK_IMPORTED_MODULE_4__components_IssueArticle__["a" /* default */]
  },
  data: function data() {
    return {
      article: null,
      page: null,
      issue: null,
      chapter: null,
      currentSlug: this.$route.params.slug
    };
  },
  created: function created() {
    var _this = this;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getSanityDocument__["a" /* default */])(this.$route.params.slug).then(function (document) {
      _this.setData(document);
    });
  },

  watch: {
    '$route.params.slug': function $routeParamsSlug() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getSanityDocument__["a" /* default */])(this.$route.params.slug).then(function (document) {
        _this2.setData(document);
      });
    }
  },

  methods: {
    setData: function setData(document) {
      if (!document || !document._type) {
        __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].replace({ path: '/404' });
      } else {
        switch (document._type) {
          case 'article':
            this.article = document;
            break;
          case 'issue':
            this.issue = document;
            break;
          case 'page':
            this.page = document;
            break;
          case 'lag':
            this.chapter = document;
            break;
        }
      }
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sanityQuery__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      content: null
    };
  },
  created: function created() {
    var _this = this;

    var query = '*[_id == "3cce2543-6b7d-47b6-a277-f5d6448e3e0c" && !(_id in path "drafts.**")]\n    {\n      "blocks": blocks {\n        "content": content[] {\n          ...,\n          "frontPageIssues": frontPageIssues[] {\n            lead,\n            "issue": frontPageIssue-> {\n              title,\n              slug,\n              "image": image {\n                ...,\n                "asset": asset->{url, metadata}\n              }\n            }\n          },\n          "image": image{"asset": asset->{url, metadata}},\n          "members": members[] {\n            role,\n            "person": person->{\n              ...,\n              "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}\n            }\n          }\n        }\n      }\n    }';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sanityQuery__["a" /* default */])(query).then(function (result) {
      _this.content = result[0].blocks.content;
    });
  },
  metaInfo: function metaInfo() {
    return {
      title: 'R\xF8d Ungdom \u2014 Organisasjonen',
      htmlAttrs: {
        lang: 'no',
        amp: undefined },
      meta: [{ name: 'title', content: 'R\xF8d Ungdom \u2014 Organisasjonen' }, { name: 'description', content: 'Her kan du lese mer om vår organisasjon, og bli medlem.' }, { name: 'twitter:title', content: 'Rød Ungdom' }, { name: 'twitter:description', content: 'Her kan du lese mer om vår organisasjon, og bli medlem.' }, { name: 'twitter:image', content: 'https://xn--rdt-0na.no/images/standard_delebilde_fb.png' }, { property: 'og:title', content: 'R\xF8d Ungdom \u2014 Organisasjonen' }, { property: 'og:description', content: 'Her kan du lese mer om vår organisasjon, og bli medlem.' }, { property: 'og:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png' }, { property: 'og:url', content: 'https://xn--rdungdom-54a.no' + this.$route.path }]
    };
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sanityQuery__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeroText__ = __webpack_require__(445);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HeroText: __WEBPACK_IMPORTED_MODULE_1__components_HeroText__["a" /* default */]
  },
  data: function data() {
    return {
      content: null
    };
  },
  created: function created() {
    var _this = this;

    var query = '*[_id == "0af82379-e832-477e-a32b-f4916e2afdf4" && !(_id in path "drafts.**")]\n    {\n      "blocks": blocks {\n        "content": content[] {\n          ...,\n          "frontPageIssues": frontPageIssues[] {\n            lead,\n            "issue": frontPageIssue-> {\n              title,\n              slug,\n              "image": image {\n                ...,\n                "asset": asset->{url, metadata}\n              }\n            }\n          },\n          "image": image{"asset": asset->{url, metadata}}\n        }\n      }\n    }';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sanityQuery__["a" /* default */])(query).then(function (result) {
      _this.content = result[0].blocks.content;
    });
  },
  metaInfo: function metaInfo() {
    return {
      title: 'R\xF8d Ungdom \u2014 Politikken',
      htmlAttrs: {
        lang: 'no',
        amp: undefined },
      meta: [{ name: 'title', content: 'R\xF8d Ungdom \u2014 Politikken' }, { name: 'description', content: 'Her kan du lese mer om hva Rød Ungdom mener.' }, { name: 'twitter:title', content: 'R\xF8d Ungdom \u2014 Politikken' }, { name: 'twitter:description', content: 'Her kan du lese mer om hva Rød Ungdom mener.' }, { name: 'twitter:image', content: 'https://xn--rdt-0na.no/images/standard_delebilde_fb.png' }, { property: 'og:title', content: 'R\xF8d Ungdom \u2014 Politikken' }, { property: 'og:description', content: 'Her kan du lese mer om hva Rød Ungdom mener.' }, { property: 'og:image', content: 'https://xn--rdungdom-54a.no/static/images/standard_delebilde_fb.png' }, { property: 'og:url', content: 'https://xn--rdungdom-54a.no' + this.$route.path }]
    };
  }
});

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eeecbc2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(361)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eeecbc2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8eeecbc2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsList_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d28700b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsList_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(363)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d28700b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d28700b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(342)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PulseLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7dc0198c_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_PulseLoader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e2bcaf2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(340)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e2bcaf2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e2bcaf2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);




!function (t, s, e) {
  "use strict";
  var i = function i(t, s) {
    var i = this;this.el = t, this.options = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(r).forEach(function (t) {
      i.options[t] = r[t];
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(s).forEach(function (t) {
      i.options[t] = s[t];
    }), this.isInput = "input" === this.el.tagName.toLowerCase(), this.attr = this.options.attr, this.showCursor = !this.isInput && this.options.showCursor, this.elContent = this.attr ? this.el.getAttribute(this.attr) : this.el.textContent, this.contentType = this.options.contentType, this.typeSpeed = this.options.typeSpeed, this.startDelay = this.options.startDelay, this.backSpeed = this.options.backSpeed, this.backDelay = this.options.backDelay, this.fadeOut = this.options.fadeOut, this.fadeOutClass = this.options.fadeOutClass, this.fadeOutDelay = this.options.fadeOutDelay, e && this.options.stringsElement instanceof e ? this.stringsElement = this.options.stringsElement[0] : this.stringsElement = this.options.stringsElement, this.strings = this.options.strings, this.strPos = 0, this.arrayPos = 0, this.stopNum = 0, this.loop = this.options.loop, this.loopCount = this.options.loopCount, this.curLoop = 0, this.stop = !1, this.cursorChar = this.options.cursorChar, this.shuffle = this.options.shuffle, this.sequence = [], this.build();
  };i.prototype = { constructor: i, init: function init() {
      var t = this;t.timeout = setTimeout(function () {
        for (var s = 0; s < t.strings.length; ++s) {
          t.sequence[s] = s;
        }t.shuffle && (t.sequence = t.shuffleArray(t.sequence)), t.typewrite(t.strings[t.sequence[t.arrayPos]], t.strPos);
      }, t.startDelay);
    }, build: function build() {
      var t = this;if (this.showCursor === !0 && (this.cursor = s.createElement("span"), this.cursor.className = "typed-cursor", this.cursor.innerHTML = this.cursorChar, this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)), this.stringsElement) {
        this.strings = [], this.stringsElement.style.display = "none";var e = Array.prototype.slice.apply(this.stringsElement.children);e.forEach(function (s) {
          t.strings.push(s.innerHTML);
        });
      }this.init();
    }, typewrite: function typewrite(t, s) {
      if (this.stop !== !0) {
        this.fadeOut && this.el.classList.contains(this.fadeOutClass) && (this.el.classList.remove(this.fadeOutClass), this.cursor.classList.remove(this.fadeOutClass));var e = Math.round(70 * Math.random()) + this.typeSpeed,
            i = this;i.timeout = setTimeout(function () {
          var e = 0,
              r = t.substr(s);if ("^" === r.charAt(0)) {
            var o = 1;/^\^\d+/.test(r) && (r = /\d+/.exec(r)[0], o += r.length, e = parseInt(r)), t = t.substring(0, s) + t.substring(s + o);
          }if ("html" === i.contentType) {
            var n = t.substr(s).charAt(0);if ("<" === n || "&" === n) {
              var a = "",
                  h = "";for (h = "<" === n ? ">" : ";"; t.substr(s + 1).charAt(0) !== h && (a += t.substr(s).charAt(0), s++, !(s + 1 > t.length));) {}s++, a += h;
            }
          }i.timeout = setTimeout(function () {
            if (s === t.length) {
              if (i.options.onStringTyped(i.arrayPos), i.arrayPos === i.strings.length - 1 && (i.options.callback(), i.curLoop++, i.loop === !1 || i.curLoop === i.loopCount)) return;i.timeout = setTimeout(function () {
                i.backspace(t, s);
              }, i.backDelay);
            } else {
              0 === s && i.options.preStringTyped(i.arrayPos);var e = t.substr(0, s + 1);i.attr ? i.el.setAttribute(i.attr, e) : i.isInput ? i.el.value = e : "html" === i.contentType ? i.el.innerHTML = e : i.el.textContent = e, s++, i.typewrite(t, s);
            }
          }, e);
        }, e);
      }
    }, backspace: function backspace(t, s) {
      var e = this;if (this.stop !== !0) {
        if (this.fadeOut) return void this.initFadeOut();var i = Math.round(70 * Math.random()) + this.backSpeed;e.timeout = setTimeout(function () {
          if ("html" === e.contentType && ">" === t.substr(s).charAt(0)) {
            for (var i = ""; "<" !== t.substr(s - 1).charAt(0) && (i -= t.substr(s).charAt(0), s--, !(s < 0));) {}s--, i += "<";
          }var r = t.substr(0, s);e.replaceText(r), s > e.stopNum ? (s--, e.backspace(t, s)) : s <= e.stopNum && (e.arrayPos++, e.arrayPos === e.strings.length ? (e.arrayPos = 0, e.shuffle && (e.sequence = e.shuffleArray(e.sequence)), e.init()) : e.typewrite(e.strings[e.sequence[e.arrayPos]], s));
        }, i);
      }
    }, initFadeOut: function initFadeOut() {
      return self = this, this.el.className += " " + this.fadeOutClass, this.cursor.className += " " + this.fadeOutClass, setTimeout(function () {
        self.arrayPos++, self.replaceText(""), self.strings.length > self.arrayPos ? self.typewrite(self.strings[self.sequence[self.arrayPos]], 0) : (self.typewrite(self.strings[0], 0), self.arrayPos = 0);
      }, self.fadeOutDelay);
    }, replaceText: function replaceText(t) {
      this.attr ? this.el.setAttribute(this.attr, t) : this.isInput ? this.el.value = t : "html" === this.contentType ? this.el.innerHTML = t : this.el.textContent = t;
    }, shuffleArray: function shuffleArray(t) {
      var s,
          e,
          i = t.length;if (i) for (; --i;) {
        e = Math.floor(Math.random() * (i + 1)), s = t[e], t[e] = t[i], t[i] = s;
      }return t;
    }, reset: function reset() {
      var t = this;clearInterval(t.timeout);this.el.getAttribute("id");this.el.textContent = "", "undefined" != typeof this.cursor && "undefined" != typeof this.cursor.parentNode && this.cursor.parentNode.removeChild(this.cursor), this.strPos = 0, this.arrayPos = 0, this.curLoop = 0, this.options.resetCallback();
    } }, i["new"] = function (t, e) {
    var r = Array.prototype.slice.apply(s.querySelectorAll(t));r.forEach(function (t) {
      var s = t._typed,
          r = "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(e)) && e;s && s.reset(), t._typed = s = new i(t, r), "string" == typeof e && s[e]();
    });
  }, e && (e.fn.typed = function (t) {
    return this.each(function () {
      var s = e(this),
          r = s.data("typed"),
          o = "object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(t)) && t;r && r.reset(), s.data("typed", r = new i(this, o)), "string" == typeof t && r[t]();
    });
  }), t.Typed = i;var r = { strings: ["These are the default values...", "You know what you should do?", "Use your own!", "Have a great day!"], stringsElement: null, typeSpeed: 0, startDelay: 0, backSpeed: 0, shuffle: !1, backDelay: 500, fadeOut: !1, fadeOutClass: "typed-fade-out", fadeOutDelay: 500, loop: !1, loopCount: !1, showCursor: !0, cursorChar: "|", attr: null, contentType: "html", callback: function callback() {}, preStringTyped: function preStringTyped() {}, onStringTyped: function onStringTyped() {}, resetCallback: function resetCallback() {} };
}(window, document, window.jQuery);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var sanityClient = __webpack_require__(30);

var client = sanityClient({
  projectId: '6usbttwh',
  dataset: 'production_new',
  useCdn: true
});

var getSanityDocument = function getSanityDocument(slug) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = '*[_type in ["issue", "article", "page", "lag"] && slug.current == \'' + slug + '\'] | {\n      ...,\n      "document": document -> { title, description,"file": file{"asset": asset->url}},\n      program{ content[]{..., "file": file{"asset": asset->url}}},\n      "related_issues": related_issues[]->{title, slug},\n      "thumbnail": thumbnail{"asset": asset->{url}},\n      "headerImage": image{..., "asset": asset->{url}},\n      "chapterHeaderImage": headerImage{image{..., "asset": asset->{url}}},\n      "groups": groups[]{title, "members": members[]{role, "person": person->{name, phone, email, facebook, twitter, instagram, "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}}}},\n      "county": county->{..., title, slug},\n      contact{..., "leader": leader->{..., "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}}},\n      "blocks": blocks{\n        "content": content[]{\n          ...,\n          "file": file{"asset": asset->url},\n          "document": document->{\n            title,\n            description,\n            "file": file{"asset": asset->url}\n          },\n          "image": image{..., "asset": asset->{url, metadata}},\n          "person": person->{\n            ...,\n            "profile_image": profile_image {\n              crop,\n              hotspot,\n              "asset": asset->{url, metadata}\n            }\n          },\n          "members": members[] {\n            role,\n            "person": person->{\n              ...,\n              "profile_image": profile_image{crop, hotspot, "asset": asset->{url, metadata}}\n            }\n          }\n        }\n      }\n    }';
    client.fetch(query).then(function (result) {
      resolve(result[0]);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSanityDocument);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lazysizes__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lazysizes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lazysizes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sanity_image_url__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sanity_image_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__sanity_image_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sanity_client__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sanity_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__sanity_client__);








var client = __WEBPACK_IMPORTED_MODULE_5__sanity_client___default()({
  projectId: '6usbttwh',
  dataset: 'production_new',
  useCdn: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$sanityImageUrl = __WEBPACK_IMPORTED_MODULE_4__sanity_image_url___default()(client);

__WEBPACK_IMPORTED_MODULE_3_lazysizes___default.a.init();

document.addEventListener('lazyloaded', function (e) {
  setTimeout(function () {
    e.target.parentNode.parentNode.style.background = 'unset';
  }, 100);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var renderBlocks = function renderBlocks(data) {
  var blocksToHtml = __webpack_require__(254);
  var h = blocksToHtml.h;
  var serializers = {
    types: {
      code: function code(props) {
        return h('pre', { className: props.node.language }, h('code', props.node.code));
      }
    }
  };

  var el = blocksToHtml({
    blocks: data,
    serializers: serializers
  });

  return el;
};

/* harmony default export */ __webpack_exports__["a"] = (renderBlocks);

/***/ }),
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 115,
	"./af.js": 115,
	"./ar": 122,
	"./ar-dz": 116,
	"./ar-dz.js": 116,
	"./ar-kw": 117,
	"./ar-kw.js": 117,
	"./ar-ly": 118,
	"./ar-ly.js": 118,
	"./ar-ma": 119,
	"./ar-ma.js": 119,
	"./ar-sa": 120,
	"./ar-sa.js": 120,
	"./ar-tn": 121,
	"./ar-tn.js": 121,
	"./ar.js": 122,
	"./az": 123,
	"./az.js": 123,
	"./be": 124,
	"./be.js": 124,
	"./bg": 125,
	"./bg.js": 125,
	"./bm": 126,
	"./bm.js": 126,
	"./bn": 127,
	"./bn.js": 127,
	"./bo": 128,
	"./bo.js": 128,
	"./br": 129,
	"./br.js": 129,
	"./bs": 130,
	"./bs.js": 130,
	"./ca": 131,
	"./ca.js": 131,
	"./cs": 132,
	"./cs.js": 132,
	"./cv": 133,
	"./cv.js": 133,
	"./cy": 134,
	"./cy.js": 134,
	"./da": 135,
	"./da.js": 135,
	"./de": 138,
	"./de-at": 136,
	"./de-at.js": 136,
	"./de-ch": 137,
	"./de-ch.js": 137,
	"./de.js": 138,
	"./dv": 139,
	"./dv.js": 139,
	"./el": 140,
	"./el.js": 140,
	"./en-au": 141,
	"./en-au.js": 141,
	"./en-ca": 142,
	"./en-ca.js": 142,
	"./en-gb": 143,
	"./en-gb.js": 143,
	"./en-ie": 144,
	"./en-ie.js": 144,
	"./en-il": 145,
	"./en-il.js": 145,
	"./en-nz": 146,
	"./en-nz.js": 146,
	"./eo": 147,
	"./eo.js": 147,
	"./es": 150,
	"./es-do": 148,
	"./es-do.js": 148,
	"./es-us": 149,
	"./es-us.js": 149,
	"./es.js": 150,
	"./et": 151,
	"./et.js": 151,
	"./eu": 152,
	"./eu.js": 152,
	"./fa": 153,
	"./fa.js": 153,
	"./fi": 154,
	"./fi.js": 154,
	"./fo": 155,
	"./fo.js": 155,
	"./fr": 158,
	"./fr-ca": 156,
	"./fr-ca.js": 156,
	"./fr-ch": 157,
	"./fr-ch.js": 157,
	"./fr.js": 158,
	"./fy": 159,
	"./fy.js": 159,
	"./gd": 160,
	"./gd.js": 160,
	"./gl": 161,
	"./gl.js": 161,
	"./gom-latn": 162,
	"./gom-latn.js": 162,
	"./gu": 163,
	"./gu.js": 163,
	"./he": 164,
	"./he.js": 164,
	"./hi": 165,
	"./hi.js": 165,
	"./hr": 166,
	"./hr.js": 166,
	"./hu": 167,
	"./hu.js": 167,
	"./hy-am": 168,
	"./hy-am.js": 168,
	"./id": 169,
	"./id.js": 169,
	"./is": 170,
	"./is.js": 170,
	"./it": 171,
	"./it.js": 171,
	"./ja": 172,
	"./ja.js": 172,
	"./jv": 173,
	"./jv.js": 173,
	"./ka": 174,
	"./ka.js": 174,
	"./kk": 175,
	"./kk.js": 175,
	"./km": 176,
	"./km.js": 176,
	"./kn": 177,
	"./kn.js": 177,
	"./ko": 178,
	"./ko.js": 178,
	"./ky": 179,
	"./ky.js": 179,
	"./lb": 180,
	"./lb.js": 180,
	"./lo": 181,
	"./lo.js": 181,
	"./lt": 182,
	"./lt.js": 182,
	"./lv": 183,
	"./lv.js": 183,
	"./me": 184,
	"./me.js": 184,
	"./mi": 185,
	"./mi.js": 185,
	"./mk": 186,
	"./mk.js": 186,
	"./ml": 187,
	"./ml.js": 187,
	"./mr": 188,
	"./mr.js": 188,
	"./ms": 190,
	"./ms-my": 189,
	"./ms-my.js": 189,
	"./ms.js": 190,
	"./mt": 191,
	"./mt.js": 191,
	"./my": 192,
	"./my.js": 192,
	"./nb": 193,
	"./nb.js": 193,
	"./ne": 194,
	"./ne.js": 194,
	"./nl": 196,
	"./nl-be": 195,
	"./nl-be.js": 195,
	"./nl.js": 196,
	"./nn": 197,
	"./nn.js": 197,
	"./pa-in": 198,
	"./pa-in.js": 198,
	"./pl": 199,
	"./pl.js": 199,
	"./pt": 201,
	"./pt-br": 200,
	"./pt-br.js": 200,
	"./pt.js": 201,
	"./ro": 202,
	"./ro.js": 202,
	"./ru": 203,
	"./ru.js": 203,
	"./sd": 204,
	"./sd.js": 204,
	"./se": 205,
	"./se.js": 205,
	"./si": 206,
	"./si.js": 206,
	"./sk": 207,
	"./sk.js": 207,
	"./sl": 208,
	"./sl.js": 208,
	"./sq": 209,
	"./sq.js": 209,
	"./sr": 211,
	"./sr-cyrl": 210,
	"./sr-cyrl.js": 210,
	"./sr.js": 211,
	"./ss": 212,
	"./ss.js": 212,
	"./sv": 213,
	"./sv.js": 213,
	"./sw": 214,
	"./sw.js": 214,
	"./ta": 215,
	"./ta.js": 215,
	"./te": 216,
	"./te.js": 216,
	"./tet": 217,
	"./tet.js": 217,
	"./tg": 218,
	"./tg.js": 218,
	"./th": 219,
	"./th.js": 219,
	"./tl-ph": 220,
	"./tl-ph.js": 220,
	"./tlh": 221,
	"./tlh.js": 221,
	"./tr": 222,
	"./tr.js": 222,
	"./tzl": 223,
	"./tzl.js": 223,
	"./tzm": 225,
	"./tzm-latn": 224,
	"./tzm-latn.js": 224,
	"./tzm.js": 225,
	"./ug-cn": 226,
	"./ug-cn.js": 226,
	"./uk": 227,
	"./uk.js": 227,
	"./ur": 228,
	"./ur.js": 228,
	"./uz": 230,
	"./uz-latn": 229,
	"./uz-latn.js": 229,
	"./uz.js": 230,
	"./vi": 231,
	"./vi.js": 231,
	"./x-pseudo": 232,
	"./x-pseudo.js": 232,
	"./yo": 233,
	"./yo.js": 233,
	"./zh-cn": 234,
	"./zh-cn.js": 234,
	"./zh-hk": 235,
	"./zh-hk.js": 235,
	"./zh-tw": 236,
	"./zh-tw.js": 236
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;

/***/ }),
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignFrontpageTop_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b7eb65_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignFrontpageTop_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(343)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignFrontpageTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b7eb65_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignFrontpageTop_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62b7eb65_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignFrontpageTop_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignMedium_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e978c84a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignMedium_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(344)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignMedium_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e978c84a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignMedium_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e978c84a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignMedium_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignNoPic_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23762026_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignNoPic_vue__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(345)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignNoPic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23762026_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignNoPic_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23762026_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignNoPic_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignNoText_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f1b36a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignNoText_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(346)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignNoText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f1b36a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignNoText_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f1b36a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignNoText_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignSquare_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dad4484_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignSquare_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(333)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CampaignSquare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dad4484_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignSquare_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dad4484_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_CampaignSquare_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterDropdown_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcdd5186_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterDropdown_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(347)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChapterDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcdd5186_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcdd5186_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChapterDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRef_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf5663c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentRef_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(348)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentRef_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf5663c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentRef_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbf5663c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentRef_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donate_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a9ab3ff_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Donate_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(349)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Donate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a9ab3ff_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Donate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a9ab3ff_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Donate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ddf42_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(350)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ddf42_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8ddf42_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPageNewsItem_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b485f8c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPageNewsItem_vue__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(351)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPageNewsItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b485f8c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPageNewsItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b485f8c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPageNewsItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontpageIssueList_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfaec996_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_FrontpageIssueList_vue__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(352)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontpageIssueList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfaec996_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_FrontpageIssueList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfaec996_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_FrontpageIssueList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleFormBlock_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ac062c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleFormBlock_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(353)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleFormBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ac062c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleFormBlock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ac062c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleFormBlock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e92c00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(354)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e92c00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e92c00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeroJerkBlock_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c17d19fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroJerkBlock_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(334)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeroJerkBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c17d19fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroJerkBlock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c17d19fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroJerkBlock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeroText_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1028645a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroText_vue__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(335)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeroText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1028645a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroText_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1028645a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeroText_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageBlock_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b157070_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_ImageBlock_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(355)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b157070_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_ImageBlock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b157070_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_ImageBlock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueArticle_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3b3b6c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueArticle_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(336)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueArticle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3b3b6c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueArticle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3b3b6c2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueArticle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueCard_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f0e7d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueCard_vue__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(357)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f0e7d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f0e7d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueList_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e52d2c5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IssueList_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(337)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e52d2c5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IssueList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e52d2c5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IssueList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueSearch_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290d5402_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueSearch_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(358)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssueSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290d5402_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueSearch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_290d5402_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_IssueSearch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkCard_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac598934_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_LinkCard_vue__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(359)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac598934_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_LinkCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac598934_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_LinkCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinksBlock_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49045080_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_LinksBlock_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(360)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinksBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49045080_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_LinksBlock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49045080_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_LinksBlock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33798a22_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(362)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33798a22_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33798a22_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsArticle_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ec5b03_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_NewsArticle_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(338)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsArticle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ec5b03_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_NewsArticle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ec5b03_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_NewsArticle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonSearch_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afa54160_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_PersonSearch_vue__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(365)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afa54160_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_PersonSearch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afa54160_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_PersonSearch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBlock_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349d4341_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBlock_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(366)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349d4341_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBlock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349d4341_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextBlock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BecomeMember_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cddc4e96_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_BecomeMember_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(367)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BecomeMember_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cddc4e96_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_BecomeMember_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cddc4e96_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_BecomeMember_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chapter_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b53588_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chapter_vue__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(339)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chapter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b53588_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chapter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68b53588_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chapter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOFour_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfa77fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_FourOFour_vue__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(368)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FourOFour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfa77fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_FourOFour_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cfa77fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_slm_optionsId_0_node_modules_vue_loader_lib_selector_type_template_index_0_FourOFour_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPage_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513c43d9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPage_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(369)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FrontPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513c43d9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_513c43d9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FrontPage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acc68d0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(370)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acc68d0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acc68d0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partiet_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d89192a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partiet_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(371)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Partiet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d89192a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partiet_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d89192a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Partiet_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Politikken_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dfad562_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Politikken_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(372)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Politikken_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dfad562_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Politikken_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dfad562_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Politikken_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Hero hero is-success is-bold is-large"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-10 is-offset-1 is-4-desktop is-offset-1-desktop"},[_c('h1',{staticClass:"Hero-heading",staticStyle:{"display":"flex","align-items":"center"}},[_vm._v("\n          Rød Ungdom ønsker å kvitte oss med kapitalismen.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"column is-10 is-offset-1 is-4-desktop is-offset-1-desktop",staticStyle:{"display":"flex","align-items":"center"}},[_c('p',{staticClass:"Hero-subHeading"},[_vm._v("\n          Vi lever i en verden med nok mat og ressurser til alle. Likevel finnes det undertrykking, klasseskiller og sult. Rød Ungdom mener kapitalismen er hovedgrunnen til det, fordi makten er så skeivt fordelt. Vi organiserer ungdom til kamp for en rettferdig verden.\n        ")]),_vm._v(" "),_c('p',{staticClass:"Hero-subHeading"})])])])])}]


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Campaign is-nopic"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8 is-offset-2 is-8-desktop is-offset-2-desktop"},[_c('div',{staticClass:"Campaign-textBox"},[_c('a',{attrs:{"href":_vm.link}},[_c('div',{staticClass:"Campaign-content"},[_c('h2',{staticClass:"Campaign-heading title"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"Campaign-readMore trailingarrow"},[_vm._v(_vm._s(_vm.ctaText))])])])])])])])])}
var staticRenderFns = []


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SearchBox IssuesSearchBox Typeahead"},[_c('div',{staticClass:"container SearchBox-container IssueSearchBox-container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"SearchBox-content"},[(_vm.title === 'Forsiden')?_c('h3',{staticClass:"title SearchBox-heading has-text-centered"},[_vm._v("Finn saker du er opptatt av")]):_c('h3',{staticClass:"title SearchBox-heading has-text-centered"},[_vm._v("Finn"),_c('a',{attrs:{"href":"/politikken#saker"}},[_vm._v("saker")]),_vm._v("du er opptatt av")])])]),_c('div',{staticClass:"column is-6 is-offset-3"},[_c('div',{staticClass:"IssueSearchResult"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],ref:"Typed",staticClass:"Typeahead-input typeahead tt-input",attrs:{"autocomplete":"off","id":"Typed","type":"text"},domProps:{"value":(_vm.term)},on:{"blur":function($event){_vm.inputFocus = false},"focus":function($event){_vm.inputFocus = true},"input":function($event){if($event.target.composing){ return; }_vm.term=$event.target.value}}}),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foundIssues.length > 0 && _vm.inputFocus),expression:"foundIssues.length > 0 && inputFocus"}],staticClass:"tt-menu"},[_c('div',{staticClass:"tt-dataset tt-dataset-issues"},_vm._l((_vm.foundIssues),function(issue){return _c('div',{staticClass:"IssuesSearchBox-item tt-suggestion tt-selectable",on:{"click":function($event){_vm.$router.push(issue.slug.current)}}},[_vm._v(_vm._s(issue.title))])}))])])],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8 is-offset-2"},[_c('div',{staticClass:"DonateBox"},[_c('h2',[_vm._v(_vm._s(_vm.text))]),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.sub))]),_c('form',{staticClass:"Form",attrs:{"action":"https://peaceful-cliffs-83180.herokuapp.com/api/v1/doner","id":"stripe-form","method":"POST","novalidate":""}},[_c('button',{staticClass:"Button is-red amount-button",attrs:{"data-amount":"10000","type":"button"},on:{"click":function($event){_vm.buttonClick(100)}}},[_vm._v("100,-")]),_c('button',{staticClass:"Button is-red amount-button",attrs:{"data-amount":"25000","type":"button"},on:{"click":function($event){_vm.buttonClick(250)}}},[_vm._v("250,-")]),_c('button',{staticClass:"Button is-red amount-button",attrs:{"data-amount":"50000","type":"button"},on:{"click":function($event){_vm.buttonClick(500)}}},[_vm._v("500,-")]),_c('button',{staticClass:"Button is-red amount-button",attrs:{"type":"button"},on:{"click":function($event){_vm.buttonClick(0)}}},[_vm._v("Annet beløp")]),_c('transition',{attrs:{"name":"fade"}},[(_vm.showForm)?_c('div',{staticClass:"DonateBox-formDetails",class:_vm.formDetails},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.stripeToken),expression:"formData.stripeToken"}],attrs:{"name":"stripeToken","type":"hidden"},domProps:{"value":(_vm.formData.stripeToken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "stripeToken", $event.target.value)}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.stripeAmount),expression:"formData.stripeAmount"}],attrs:{"name":"stripeAmount","type":"hidden"},domProps:{"value":(_vm.formData.stripeAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "stripeAmount", $event.target.value)}}}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userEmail),expression:"formData.userEmail"}],attrs:{"name":"userEmail","type":"hidden"},domProps:{"value":(_vm.formData.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "userEmail", $event.target.value)}}}),_c('hr'),_c('div',{staticClass:"control is-grouped Form-control"},[_c('p',{staticClass:"control Form-control"},[_c('label',{staticClass:"label"},[_vm._v("Beløp")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.stripeAmount),expression:"formData.stripeAmount"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",attrs:{"id":"AmountInput","name":"Beløp","type":"number"},domProps:{"value":(_vm.formData.stripeAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "stripeAmount", $event.target.value)}}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Beløp')),expression:"errors.has('Beløp')"}],staticClass:"form-error"},[_vm._v(_vm._s(_vm.errors.first('Beløp')))])]),_c('p',{staticClass:"control Form-control is-expanded"},[_c('label',{staticClass:"label"},[_vm._v("Fullt navn")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.navn),expression:"formData.navn"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",attrs:{"name":"Navn","type":"text"},domProps:{"value":(_vm.formData.navn)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "navn", $event.target.value)}}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Navn')),expression:"errors.has('Navn')"}],staticClass:"form-error"},[_vm._v(_vm._s(_vm.errors.first('Navn')))])])]),_c('div',{staticClass:"control is-grouped Form-control"},[_c('p',{staticClass:"control is-expanded Form-control"},[_c('label',{staticClass:"label",attrs:{"for":"email"}},[_vm._v("E-post")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.userEmail),expression:"formData.userEmail"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"input is-large",attrs:{"id":"email","name":"Epost","type":"email"},domProps:{"value":(_vm.formData.userEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "userEmail", $event.target.value)}}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Epost')),expression:"errors.has('Epost')"}],staticClass:"form-error"},[_vm._v(_vm._s(_vm.errors.first('Epost')))])]),_c('p',{staticClass:"control Form-control"},[_c('label',{staticClass:"label"},[_vm._v("Postnummer")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formData.zip),expression:"formData.zip"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",attrs:{"max":"9999","name":"Postnummer","type":"number"},domProps:{"value":(_vm.formData.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formData, "zip", $event.target.value)}}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Postnummer')),expression:"errors.has('Postnummer')"}],staticClass:"form-error"},[_vm._v(_vm._s(_vm.errors.first('Postnummer')))])])]),_c('div',{staticClass:"control Form-control"},[_c('p',{staticClass:"control"},[_c('label',{staticClass:"label"},[_vm._v("Kortinformasjon")]),_c('card',{staticClass:"stripe-card field",class:{ cardComplete: _vm.cardComplete },attrs:{"options":_vm.options,"stripe":_vm.key},on:{"change":_vm.cardUpdate}})],1),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.cardError),expression:"cardError"}],staticClass:"card-error"},[_vm._v(_vm._s(_vm.cardError))]),_c('p')]),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button Button is-primary is-marginless send-button",class:{'is-loading' : _vm.formIsLoading},attrs:{"disabled":!_vm.cardComplete,"type":"button"},on:{"click":_vm.pay}},[_vm._v("Betal")])])]):_vm._e()])],1)])])])])])}
var staticRenderFns = []


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.size === 'Lite')?_c('div',{staticClass:"container"},[_c('div',{staticClass:"column is-8 is-7-widescreen is-offset-2 is-paddingless-mobile"},[_c('figure',{ref:"imageContainer",staticClass:"Figure",attrs:{"itemprop":"image","itemscope":"","itemtype":"http://schema.org/ImageObject"}},[(_vm.width)?_c('image-source',{attrs:{"alt":_vm.caption,"ratio":1.78,"source":_vm.imageUrl,"width":_vm.width,"widths":_vm.smallWidths}}):_vm._e(),_c('meta',{attrs:{"content":"true","itemprop":"representativeOfPage"}}),_c('meta',{attrs:{"content":"1360","itemprop":"width"}}),_c('meta',{attrs:{"content":"#{1360/1.78}","itemprop":"height"}}),_c('meta',{attrs:{"content":"metaContentUrl","itemprop":"url contentUrl"}}),_c('figcaption',{staticClass:"Figure-caption"},[_c('div',{staticClass:"content"},[_c('p',{attrs:{"itemprop":"caption"}},[_vm._v(_vm._s(_vm.caption))])])])],1)])]):(_vm.size === 'Medium')?_c('div',{staticClass:"container"},[_c('div',{staticClass:"column is-10 is-offset-1 is-paddingless-mobile"},[_c('figure',{ref:"imageContainer",staticClass:"Figure",attrs:{"itemprop":"image","itemscope":"","itemtype":"http://schema.org/ImageObject"}},[(_vm.width)?_c('image-source',{attrs:{"alt":_vm.caption,"ratio":1.78,"source":_vm.imageUrl,"width":_vm.width,"widths":_vm.mediumWidths}}):_vm._e(),_c('meta',{attrs:{"content":"true","itemprop":"representativeOfPage"}}),_c('meta',{attrs:{"content":"1360","itemprop":"width"}}),_c('meta',{attrs:{"content":"#{1360/1.78}","itemprop":"height"}}),_c('meta',{attrs:{"content":"metaContentUrl","itemprop":"url contentUrl"}}),_c('figcaption',{staticClass:"Figure-caption"},[_c('div',{staticClass:"content"},[_c('p',{attrs:{"itemprop":"caption"}},[_vm._v(_vm._s(_vm.caption))])])])],1)])]):(_vm.size === 'Stort')?_c('div',{staticClass:"container"},[_c('div',{staticClass:"column is-12 is-paddingless-mobile"},[_c('figure',{ref:"imageContainer",staticClass:"Figure",attrs:{"itemprop":"image","itemscope":"","itemtype":"http://schema.org/ImageObject"}},[(_vm.width)?_c('image-source',{attrs:{"alt":_vm.caption,"ratio":1.78,"source":_vm.imageUrl,"width":_vm.width,"widths":_vm.bigWidths}}):_vm._e(),_c('meta',{attrs:{"content":"true","itemprop":"representativeOfPage"}}),_c('meta',{attrs:{"content":"1360","itemprop":"width"}}),_c('meta',{attrs:{"content":"#{1360/1.78}","itemprop":"height"}}),_c('meta',{attrs:{"content":"metaContentUrl","itemprop":"url contentUrl"}}),_c('figcaption',{staticClass:"Figure-caption"},[_c('div',{staticClass:"content"},[_c('p',{attrs:{"itemprop":"caption"}},[_vm._v(_vm._s(_vm.caption))])])])],1)])]):(_vm.size === 'Fullbredde' || !_vm.size)?_c('figure',{ref:"imageContainer",staticClass:"Figure",attrs:{"itemprop":"image","itemscope":"","itemtype":"http://schema.org/ImageObject"}},[(_vm.width)?_c('image-source',{attrs:{"alt":_vm.caption,"ratio":1.78,"source":_vm.imageUrl,"width":_vm.width,"widths":_vm.mediumWidths}}):_vm._e(),_c('meta',{attrs:{"content":"true","itemprop":"representativeOfPage"}}),_c('meta',{attrs:{"content":"1360","itemprop":"width"}}),_c('meta',{attrs:{"content":"#{1360/1.78}","itemprop":"height"}}),_c('meta',{attrs:{"content":"metaContentUrl","itemprop":"url contentUrl"}}),_c('figcaption',{staticClass:"Figure-caption"},[_c('div',{staticClass:"content"},[_c('p',{attrs:{"itemprop":"caption"}},[_vm._v(_vm._s(_vm.caption))])])])],1):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('block-render',{attrs:{"blocks":_vm.content}}):_c('div',{staticStyle:{"height":"1000px"}})}
var staticRenderFns = []


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Campaign is-square",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6-widescreen is-offset-1-widescreen is-7-tablet is-offset-1-tablet"},[_c('div',{ref:"imageContainer",staticClass:"Campaign-image"},[(_vm.width)?_c('image-source',{attrs:{"alt":_vm.text,"ratio":1,"source":_vm.imageUrl,"width":_vm.width,"widths":_vm.widths}}):_vm._e()],1),_c('div',{staticClass:"Campaign-textBox"},[_c('router-link',{attrs:{"to":_vm.link}},[_c('div',{staticClass:"Campaign-content"},[_c('h2',{staticClass:"Campaign-heading title"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"Campaign-readMore trailingarrow"},[_vm._v(_vm._s(_vm.ctaText))])])])],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{'Folk' : _vm.$route.name === 'Organisasjonen'}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[(_vm.$route.name === 'Organisasjonen')?_c('div',{staticClass:"column is-12 PersonCard-list"},[_c('h2',{staticClass:"title sectionHeading"},[_vm._v(_vm._s(_vm.title))])]):_c('div',{staticClass:"column",class:_vm.$route.name === 'Chapter'? 'is-12' : 'is-8 is-offset-2 is-7-widescreen'},[_c('div',{staticClass:"content"},[_c('h4',[_vm._v(_vm._s(_vm.title))])])]),_c('div',{staticClass:"column",class:_vm.$route.name === 'Chapter' || _vm.$route.name === 'Organisasjonen' ? 'is-12' : 'is-10 is-offset-1'},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"PersonCard-list columns is-multiline"},_vm._l((_vm.members),function(member){return _c('div',{staticClass:"column",class:_vm.$route.name === 'Organisasjonen' ? 'is-4' : 'is-half'},[_c('person-card',{attrs:{"person":member.person,"role":member.role}})],1)}))])])])])])}
var staticRenderFns = []


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"Navigation"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12 is-paddingless-mobile"},[_c('router-link',{staticClass:"Navigation-logo",attrs:{"to":"/"}},[_c('div',{staticClass:"Logo"})]),_vm._v(" "),_c('router-link',{staticClass:"Navigation-link",class:{'is-selected' : (_vm.$route.name === 'Politikken')},attrs:{"to":"/politikken"}},[_vm._v("Politikken")]),_vm._v(" "),_c('router-link',{staticClass:"Navigation-link",class:{'is-selected' : (_vm.$route.name === 'Organisasjonen')},attrs:{"to":"/organisasjonen"}},[_vm._v("Organisasjonen")]),_vm._v(" "),_c('router-link',{staticClass:"Navigation-link is-red is-hidden-tablet is-marginless",attrs:{"to":"/bli-medlem"}},[_vm._v("Bli medlem")]),_vm._v(" "),_c('router-link',{staticClass:"Button is-red is-outline is-hidden-mobile NavMem",attrs:{"to":"/bli-medlem"}},[_vm._v("Bli medlem ")])],1)])])])}
var staticRenderFns = []


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wrapClasses)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{class:_vm.wrapClasses},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.rawhtml)}})])])]):_c('div',{},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.rawhtml)}})])}
var staticRenderFns = []


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Campaign is-notext"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-10 is-offset-1"},[_c('div',{ref:"imageContainer",staticClass:"Campaign-image"},[_c('a',{attrs:{"href":_vm.link}},[_c('figure',{staticClass:"image"},[_c('image-source',{attrs:{"alt":_vm.link,"q":100,"ratio":1.78,"source":_vm.imageUrl,"width":_vm.width,"widths":_vm.widths}})],1)])])])])])])}
var staticRenderFns = []


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.article)?_c('loader'):_c('article',{staticClass:"Article",attrs:{"itemscope":"","itemtype":"http://schema.org/NewsArticle","role":"article"}},[_c('meta',{attrs:{"content":'https://rødungdom.no' + _vm.$route.path,"itemprop":"mainEntityOfPage"}}),_c('meta',{attrs:{"content":"Rød Ungdom","itemprop":"author"}}),_c('div',{staticClass:"is-hidden",attrs:{"itemprop":"publisher","itemscope":"","itemtype":"http://schema.org/Organization"}},[_c('meta',{attrs:{"content":"Rød Ungdom","itemprop":"name"}}),_c('link',{attrs:{"href":"http://rødungdom.no","itemprop":"sameAs"}}),_c('div',{attrs:{"itemprop":"logo","itemscope":"","itemtype":"http://schema.org/ImageObject"}},[_c('meta',{attrs:{"content":"https://rødungdom.no/static/images/ru_logo.png","itemprop":"url"}}),_c('meta',{attrs:{"content":"120","itemprop":"width"}}),_c('meta',{attrs:{"content":"120","itemprop":"height"}})]),(_vm.article.thumbnail)?_c('meta',{attrs:{"content":_vm.article.thumbnail.asset.url + '?w=1200&h=630',"itemprop":"thumbnailUrl"}}):_vm._e()]),_c('header',[_c('section',{staticClass:"Article-headerSection",class:{'is-page': _vm.article._type === 'page'},staticStyle:{"position":"relative"}},[_c('div',{ref:"imageContainer",staticClass:"Article-headerImage",style:(_vm.setBackgroundImage)}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"column is-8 is-offset-2 is-12-mobile"},[_c('div',{staticClass:"content"},[_c('h1',{staticStyle:{"margin-top":"0","margin-bottom":"0"},attrs:{"itemprop":"headline"}},[_vm._v(_vm._s(_vm.article.title))])])])])]),_c('div',{staticClass:"container Article-contentContainer"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-9 is-offset-1 Article-metaContainer"},[(_vm.article._type.indexOf('article') > -1)?_c('p',{staticClass:"Article-metadata"},[_vm._v("Publisert "+_vm._s(_vm.convertDate(_vm.article._createdAt))),_c('br',{staticClass:"is-hidden-tablet"}),(_vm.article._createdAt < _vm.article._updatedAt)?_c('span',[_c('span',{staticClass:"is-hidden-mobile"},[_vm._v(" ● ")]),_vm._v("Sist oppdatert "+_vm._s(_vm.convertDate(_vm.article._updatedAt)))]):_vm._e()]):_vm._e(),(_vm.article._createdAt < _vm.article._updatedAt)?_c('meta',{attrs:{"content":_vm.convertDate(_vm.article._updatedAt),"itemprop":"dateModified"}}):_vm._e(),_c('meta',{attrs:{"content":_vm.convertDate(_vm.article._createdAt),"itemprop":"datePublished"}})]),(_vm.article.lead)?_c('div',{staticClass:"column is-8 is-offset-2 is-7-widescreen"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"lead-in",staticStyle:{"margin-bottom":"0"},attrs:{"itemprop":"description"}},[_vm._v(_vm._s(_vm.article.lead))])])]):_vm._e()])])]),(_vm.article.blocks)?_c('block-render',{attrs:{"blocks":_vm.article.blocks.content,"textWrapClasses":_vm.classes}}):_vm._e(),_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7 is-offset-2"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-clearfix"},[_c('a',{staticClass:"is-pulled-right Button is-outline is-font-sans Sharebutton",attrs:{"href":_vm.shareUrl}},[_vm._v("Del på Facebook")])])])])])])]),(_vm.relatedIssues && _vm.relatedIssues.length > 0)?_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7 is-offset-2"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Les mer om hva vi mener om")]),_vm._l((_vm.relatedIssues),function(relatedIssue){return _c('div',{staticClass:"IssueList-item"},[_c('router-link',{attrs:{"to":_vm.getSlug(relatedIssue)}},[_vm._v(_vm._s(relatedIssue.title))])],1)})],2)])])])]):_vm._e()],1)}
var staticRenderFns = []


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"greyback"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.links),function(link,index){return _c('div',{staticClass:"column",class:_vm.isEven(index) ? 'is-6-tablet is-5-desktop is-offset-1-desktop is-3-widescreen is-offset-0-widescreen' : 'is-6-tablet is-5-desktop is-3-widescreen'},[_c('link-card',{key:link.id,attrs:{"link":link}})],1)}))])])}
var staticRenderFns = []


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('block-render',{attrs:{"blocks":_vm.content}}):_c('div',{staticStyle:{"height":"1000px"}})}
var staticRenderFns = []


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-8 is-offset-2 is-7-widescreen"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"GoogleForm"}),_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":_vm.url + '?embedded=true',"frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("Laster skjema...")])])])])])}
var staticRenderFns = []


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-4",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"ArticleList-item"},[_c('router-link',{staticClass:"ArticleList-imageContainer",attrs:{"to":_vm.slug}},[_c('image-source',{attrs:{"hotspot":_vm.image.hotspot,"crop":_vm.image.crop,"metadata":_vm.image.asset.metadata,"source":_vm.image.asset.url,"widths":_vm.widths,"ratio":1.78,"alt":_vm.title}})],1),_vm._v(" "),_c('div',{staticClass:"ArticleList-textContainer"},[_c('h4',{staticClass:"title is-3"},[_c('router-link',{attrs:{"to":_vm.slug}},[_vm._v(_vm._s(_vm.title))])],1),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"0"}},[_vm._v("\n        "+_vm._s(_vm.lead)+"\n      ")])])],1)])}
var staticRenderFns = []


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.issuesByLetter.length > 0)?_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"column is-10-tablet is-offset-1-tablet is-8-widescreen is-offset-2-widescreen"},_vm._l((_vm.issuesByLetter),function(issues){return _c('div',{staticClass:"content"},[(issues.issues.length > 0)?_c('h4',{staticStyle:{"margin-top":"44px"}},[_vm._v(_vm._s(issues.letter))]):_vm._e(),_vm._v(" "),_vm._l((issues.issues),function(issue){return _c('div',{key:issue.title,staticClass:"IssueList-item"},[_c('router-link',{staticClass:"IssueList-link",attrs:{"to":_vm.getSlug(issue)}},[_vm._v(_vm._s(issue.title))])],1)})],2)}))])]):_vm._e()}
var staticRenderFns = []


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"Campaign is-big is-frontpage"},[_c('div',{staticClass:"Campaign-imageContainer",style:(_vm.imageStyle)})])]),_c('div',{staticClass:"column is-6"},[_c('div',{staticClass:"Campaign is-big is-frontpage Campaign-contentContainer"},[_c('div',{staticClass:"textbox Campaign-content",attrs:{"onClick":_vm.onclick}},[_c('h2',[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"Campaign-readMore is-white is-big trailingarrow",attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.linkText))])])])])])])])}
var staticRenderFns = []


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column Issue is-3-desktop is-6-tablet is-12-mobile",style:({display: 'flex'})},[_c('router-link',{staticClass:"IssueList-card",attrs:{"to":_vm.issue.issue.slug.current}},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.issue.issue.title))]),_c('p',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.issue.lead))]),_c('div',{staticClass:"imgContainter"},[_c('image-source',{attrs:{"alt":_vm.issue.title,"ratio":1.78,"source":_vm.issue.issue.image.asset.url,"widths":_vm.widths}})],1)])],1)}
var staticRenderFns = []


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('header',{staticClass:"Lokallag-header"},[(_vm.data.chapterHeaderImage)?_c('div',{staticClass:"Lokallag-header-image",style:({backgroundImage: 'url('+_vm.data.chapterHeaderImage.image.asset.url+'?w=3000&h=700)'})}):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"Lokallag-navigation"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-10 is-offset-1 has-text-centered"},[_c('div',{staticClass:"content",staticStyle:{"margin-bottom":"0"}},[_c('h2',{staticClass:"Lokallag-heading"},[_vm._v(_vm._s(_vm.data.title))])])])])])]),_vm._v(" "),_c('div',{staticClass:"columns"},[(_vm.articles.length > 0)?_c('div',{staticClass:"column is-12 is-4-desktop is-offset-1-desktop"},[_c('section',{staticClass:"ArticleList",staticStyle:{"padding-top":"0"}},[_c('h3',{staticClass:"title sectionHeading"},[_vm._v("Siste nytt")]),_vm._v(" "),_vm._l((_vm.articles),function(article){return _c('div',{staticClass:"ArticleList-item"},[_c('router-link',{attrs:{"to":_vm.data.slug.current + article.slug.current}},[(article.thumbnail)?_c('image-source',{attrs:{"hotspot":article.thumbnail.asset.hotspot,"crop":article.thumbnail.asset.crop,"metadata":article.thumbnail.asset.metadata,"source":article.thumbnail.asset.url,"widths":_vm.widths,"ratio":1.78,"alt":article.title}}):_vm._e()],1),_vm._v(" "),_c('h4',{staticClass:"title ArticleList-title",staticStyle:{"margin-bottom":"0","display":"inline"}},[_c('router-link',{staticStyle:{"margin-bottom":"0"},attrs:{"to":_vm.data.slug.current + '/' + article.slug.current}},[_vm._v(_vm._s(article.title))])],1),_vm._v(" "),_c('p',{staticClass:"is-font-sans",staticStyle:{"margin-bottom":"44px"}},[_vm._v(_vm._s(article.lead))])],1)})],2)]):_vm._e(),_vm._v(" "),(_vm.data.contact)?_c('div',{staticClass:"column is-12 is-5-desktop is-offset-1-desktop"},[_c('section',{staticClass:"Lokallag-contact"},[_c('table',[_c('tr',[_vm._m(0),_vm._v(" "),_c('td',[_c('person-card',{attrs:{"person":_vm.data.contact.leader}})],1)]),_vm._v(" "),(_vm.data.contact.email)?_c('tr',[_vm._m(1),_vm._v(" "),_c('td',[_c('p',[_c('a',{staticClass:"is-font-mono",attrs:{"href":_vm.data.contact.email}},[_vm._v(_vm._s(_vm.data.contact.email))])])])]):_vm._e(),_vm._v(" "),(_vm.data.contact.address)?_c('tr',[_vm._m(2),_vm._v(" "),_c('td',[_c('p'),_c('p',{staticClass:"is-font-mono",staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.data.contact.address))]),_vm._v(" "),_c('p')])]):_vm._e(),_vm._v(" "),(_vm.chapters.length > 0)?_c('tr',[_vm._m(3),_vm._v(" "),_c('td',[_c('form',{staticClass:"Form"},[_c('span',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","selected":""}},[_vm._v("Velg lokallag")]),_vm._v(" "),_vm._l((_vm.chapters),function(chapter){return _c('option',{domProps:{"value":chapter.slug.current}},[_vm._v("\n                        "+_vm._s(chapter.title)+"\n                      ")])})],2)])])])]):_vm._e()]),_vm._v(" "),(_vm.data.contact.external_site)?_c('div',[(_vm.data.contact.external_site.indexOf('facebook') > -1)?_c('div',{staticClass:"Button is-Facebook",attrs:{"type":"button"},on:{"click":function($event){this.open(_vm.data.contact.external_site)}}},[_c('icon',{attrs:{"name":"facebook-official"}}),_vm._v(" Finn oss på Facebook\n            ")],1):(_vm.data.contact.external_site)?_c('div',{staticClass:"Button",attrs:{"type":"button"},on:{"click":function($event){this.open(_vm.data.contact.external_site)}}},[_vm._v("\n              Besøk nettsiden vår\n            ")]):_vm._e()]):_vm._e()])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('p',[_c('strong',[_vm._v("Leder")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('p',[_c('strong',[_vm._v("E-post")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('p',[_c('strong',[_vm._v("Adresse")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('p',[_c('strong',[_vm._v("Lokallag")])])])}]


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"Footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"column is-4 is-3-desktop",attrs:{"itemscope":"","itemtype":"http://schema.org/Person"}}),_c('div',{staticClass:"column is-4 is-3-desktop"},[_c('p',[_c('a',{attrs:{"href":"https://www.facebook.com/rodungdomnorge","target":"_blank"}},[_c('icon',{attrs:{"name":"facebook-official"}}),_vm._v("Facebook")],1),_c('br'),_c('a',{attrs:{"href":"https://www.instagram.com/rod_ungdom/","target":"_blank"}},[_c('icon',{attrs:{"name":"instagram"}}),_vm._v("Instagram")],1),_c('br'),_c('a',{attrs:{"href":"https://twitter.com/rodungdom","target":"_blank"}},[_c('icon',{attrs:{"name":"twitter"}}),_vm._v("Twitter")],1),_c('br'),_c('a',{attrs:{"href":"/personvernerklaering"}},[_vm._v("Personvernerklæring")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-12 is-3-desktop is-2-widescreen"},[_c('img',{attrs:{"alt":"Rød Ungdom","src":"/static/images/ru_logo_hvit.svg","width":"120"}}),_c('a',{staticClass:"is-hidden",attrs:{"href":"https://rødungdom.no"}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v(" Rød Ungdom")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-4 is-3-desktop"},[_c('p',[_c('span',{staticClass:"Knekk"},[_vm._v("Dronningens gate 22")]),_c('span',[_vm._v("0154 Oslo")]),_c('br'),_c('a',{attrs:{"href":"tel:229890(0"}},[_vm._v("22 98 90 70")]),_c('br'),_c('a',{attrs:{"href":"mailto:ru@sosialisme.no"}},[_vm._v("ru@sosialisme.no")])])])}]


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.article || _vm.page)?_c('newsarticle',{attrs:{"article":_vm.article || _vm.page}}):(_vm.issue)?_c('issue-article',{attrs:{"article":_vm.issue}}):(_vm.chapter)?_c('chapter',{attrs:{"data":_vm.chapter}}):_c('div',{staticStyle:{"height":"10000px"}})}
var staticRenderFns = []


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ratioContainer",style:(_vm.containerStyle)},[_c('picture',[_c('source',{attrs:{"type":"image/webp","data-srcset":_vm.widths.map(function (w) { return (
            _vm.imageUrl
              .image(_vm.source)
              .width(w)
              .height(parseInt(w / _vm.ratio, 10))
              .fit(_vm.fit || 'crop')
              .format('webp')
              .quality(80)
              .url() + " " + w + "w"
          ); }).join(', ')}}),_vm._v(" "),_c('source',{attrs:{"data-srcset":_vm.widths.map(function (w) { return (
            _vm.imageUrl
              .image(_vm.source)
              .width(w)
              .height(parseInt(w / _vm.ratio, 10))
              .fit(_vm.fit || 'crop')
              .format(_vm.transparent ? 'png' : 'jpg')
              .quality(80)
              .url() + " " + w + "w"
          ); }).join(', ')}}),_vm._v(" "),_c('img',{ref:"imageEl",staticClass:"lazyload blurUp",attrs:{"data-parent-fit":"contain","src":_vm.lqip,"data-sizes":"auto","alt":_vm.alt}})])])}
var staticRenderFns = []


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8 is-offset-2"},[_c('h1',{staticStyle:{"text-align":"center"}},[_c('br'),_vm._v("😟")]),_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Kunne ikke finne siden.")])])])])}]


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'container' : _vm.wrap}},[_c('div',{class:_vm.wrap},[_c('div',{staticClass:"PersonCard-container"},[_c('div',{staticClass:"PersonCard",attrs:{"itemscope":"","itemtype":"http://schema.org/Person"}},[(!_vm.person.profile_image)?_c('div',{staticClass:"PersonCard-noImage"},[_c('h3',[_vm._v(_vm._s(_vm.person.name.replace(/[^A-Z-ÆØÅ]/g, '')))])]):_c('figure',{staticClass:"PersonCard-image",attrs:{"itemprop":"image"}},[_c('image-source',{attrs:{"ratio":1,"source":_vm.person.profile_image.asset.url,"hotspot":_vm.person.profile_image.hotspot,"crop":_vm.person.profile_image.crop,"metadata":_vm.person.profile_image.asset.metadata,"alt":_vm.person.name,"widths":[200, 200, 600]}})],1),_vm._v(" "),_c('div',{staticClass:"PersonCard-content"},[_c('div',{staticClass:"content"},[(_vm.role)?_c('p',{staticClass:"PersonCard-status",attrs:{"itemprop":"jobTitle"}},[_vm._v("\n              "+_vm._s(_vm.role)+"\n            ")]):_vm._e(),_vm._v(" "),_c('h3',{attrs:{"itemprop":"name"}},[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),(_vm.person.phone)?_c('p',[_c('a',{attrs:{"href":this.phoneLink(_vm.person.phone)}},[_vm._v(_vm._s(_vm.person.phone))])]):_vm._e(),_vm._v(" "),(_vm.person.email)?_c('p',{staticClass:"Person-card-mail-desktop"},[_c('a',{attrs:{"href":this.mailTo(_vm.person.email)}},[_vm._v(_vm._s(_vm.person.email))])]):_vm._e(),_vm._v(" "),(_vm.person.email)?_c('a',{staticClass:"Person-card-mail-mobile",attrs:{"href":this.mailTo(_vm.person.email)}},[_c('icon',{attrs:{"name":"envelope-o"}})],1):_vm._e(),_vm._v(" "),(_vm.person.twitter)?_c('a',{staticClass:"fa-twitter",attrs:{"href":this.twitterLink(_vm.person.twitter),"target":"_blank"}},[_c('icon',{attrs:{"name":"twitter"}})],1):_vm._e(),_vm._v(" "),(_vm.person.facebook)?_c('a',{attrs:{"href":_vm.person.facebook,"target":"_blank"}},[_c('icon',{attrs:{"name":"facebook-official"}})],1):_vm._e(),_vm._v(" "),(_vm.person.instagram)?_c('a',{attrs:{"href":this.instagramLink(_vm.person.instagram),"target":"_blank"}},[_c('icon',{attrs:{"name":"instagram"}})],1):_vm._e()])])])])])])}
var staticRenderFns = []


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-pulse v-pulse1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_c('div',{staticClass:"v-pulse v-pulse2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_c('div',{staticClass:"v-pulse v-pulse3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])}
var staticRenderFns = []


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navbar'),_vm._v(" "),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_vm._v(" "),_c('foot')],1)}
var staticRenderFns = []


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Loader-container"},[_c('pulse-loader',{staticClass:"Loader",attrs:{"color":_vm.spinnerColor}})],1)}
var staticRenderFns = []


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('hero-text'),_vm._v(" "),(_vm.content)?_c('block-render',{attrs:{"blocks":_vm.content}}):_c('div',{staticStyle:{"height":"1000px"}})],1)}
var staticRenderFns = []


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Column-box"},[_c('a',{staticClass:"Column-box-content",attrs:{"href":_vm.link.url}},[_c('h2',{staticClass:"title Title-only"},[_vm._v(_vm._s(_vm.link.title))]),_c('p',[_vm._v(_vm._s(_vm.link.description))])])])}
var staticRenderFns = []


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Folk",staticStyle:{"margin-bottom":"88px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12"},[_c('div',{staticClass:"SearchBox-content"},[_c('h4',{staticClass:"title SearchBox-heading has-text-centered"},[_vm._v(_vm._s(_vm.title))])])]),_c('div',{staticClass:"column is-6-widescreen is-offset-3-widescreen is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"},[_c('div',{staticClass:"PeopleSearchResult Typeahead",style:({position: 'relative'})},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.term),expression:"term"}],staticClass:"Typeahead-input typeahead",attrs:{"autocomplete":"off","placeholder":"Fyll inn navn du leter etter","type":"text"},domProps:{"value":(_vm.term)},on:{"input":function($event){if($event.target.composing){ return; }_vm.term=$event.target.value}}}),(_vm.searching)?_c('pulse-loader',{staticClass:"Spinner",attrs:{"color":"#aaa","size":"10px"}}):_vm._e()],1)])]),(_vm.foundPeople.length > 0)?_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.foundPeople),function(person){return _c('div',{staticClass:"column is-6 is-4-widescreen"},[_c('person-card',{key:person._id,attrs:{"person":person}})],1)})):(_vm.searched)?_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",style:({textAlign: 'center'})},[_c('h3',[_vm._v("Fant ingen ved det navnet")])])]):_vm._e()])])}
var staticRenderFns = []


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"HeroJerkBlock"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-5 is-offset-1"},[_c('div',{staticClass:"WeekHero"},[_c('h4',{staticClass:"is-padded is-pulled-left"},[_vm._v("Ukas helt 😚")]),_vm._v(" "),_c('div',{style:({position: 'relative', paddingBottom: '40px'})},[_c('image-source',{attrs:{"source":_vm.hero.image.asset.url,"widths":_vm.widths,"ratio":1.78,"alt":_vm.hero.name}}),_vm._v(" "),_c('div',{staticClass:"HeroJerk-titleContainer"},[_c('h3',{staticClass:"HeroJerk-title is-padded has-text-centered",on:{"click":function($event){_vm.displayHeroText = !_vm.displayHeroText}}},[_vm._v("\n                "+_vm._s(_vm.hero.name)+" \n                "),(!_vm.displayHeroText)?_c('icon',{attrs:{"name":"chevron-down"}}):_vm._e(),_vm._v(" "),(_vm.displayHeroText)?_c('icon',{attrs:{"name":"chevron-up"}}):_vm._e()],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.displayHeroText)?_c('div',{staticClass:"HeroJerk-textContainer"},[_c('p',[_c('pre',[_vm._v(_vm._s(_vm.hero.text))])])]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"column is-5"},[_c('div',{staticClass:"WeekJerk"},[_c('h4',{staticClass:"is-padded is-pulled-left"},[_vm._v("Ukas dust 😣")]),_vm._v(" "),_c('div',{style:({position: 'relative', paddingBottom: '40px'})},[_c('image-source',{attrs:{"source":_vm.jerk.image.asset.url,"widths":_vm.widths,"ratio":1.78,"alt":_vm.jerk.name}}),_vm._v(" "),_c('div',{staticClass:"HeroJerk-titleContainer"},[_c('h3',{staticClass:"HeroJerk-title is-padded has-text-centered",on:{"click":function($event){_vm.displayJerkText = !_vm.displayJerkText}}},[_vm._v("\n                "+_vm._s(_vm.jerk.name)+" \n                "),(!_vm.displayJerkText)?_c('icon',{attrs:{"name":"chevron-down"}}):_vm._e(),_vm._v(" "),(_vm.displayJerkText)?_c('icon',{attrs:{"name":"chevron-up"}}):_vm._e()],1)])],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.displayJerkText)?_c('div',{staticClass:"HeroJerk-textContainer"},[_c('p',[_c('pre',[_vm._v(_vm._s(_vm.jerk.text))])])]):_vm._e()])],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_vm._m(0),_c('article',{staticClass:"Article"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-7-widescreen is-offset-0-widescreen is-10-tablet is-offset-1-tablet"},[_c('form',{ref:"memberForm",staticClass:"Form",attrs:{"action":"/velkommen","id":"stripe-form","name":"innmelding","netlify":"","novalidate":""}},[_c('input',{attrs:{"name":"form-name","type":"hidden","value":"innmelding"}}),_c('div',{staticClass:"control is-grouped Form-control"},[_c('p',{staticClass:"control Form-control is-expanded"},[_c('label',{staticClass:"label"},[_vm._v("Fullt navn")]),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",class:{'is-danger': _vm.errors.has('navn')},attrs:{"name":"navn","type":"text"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('navn')),expression:"errors.has('navn')"}],staticClass:"form-error"},[_vm._v("Feltet må fylles ut")])])]),_c('div',{staticClass:"control Form-control"},[_c('p',{staticClass:"control is-expanded Form-control"},[_c('label',{staticClass:"label"},[_vm._v("Gateadresse")]),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",class:{'is-danger': _vm.errors.has('Gatenavn')},attrs:{"name":"Gatenavn","type":"text"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Gatenavn')),expression:"errors.has('Gatenavn')"}],staticClass:"form-error"},[_vm._v("Feltet må fylles ut")])])]),_c('div',{staticClass:"control is-grouped Form-control"},[_vm._m(1),_c('p',{staticClass:"control Form-control"},[_c('label',{staticClass:"label"},[_vm._v("Postnummer")]),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",class:{'is-danger': _vm.errors.has('Postnummer')},attrs:{"max":"9999","name":"Postnummer","type":"number"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Gatenavn')),expression:"errors.has('Gatenavn')"}],staticClass:"form-error"},[_vm._v("Feltet må fylles ut")])]),_c('p',{staticClass:"control is-expanded Form-control"},[_c('label',{staticClass:"label"},[_vm._v("Poststed")]),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",class:{'is-danger': _vm.errors.has('Poststed')},attrs:{"name":"Poststed","type":"text"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Poststed')),expression:"errors.has('Poststed')"}],staticClass:"form-error"},[_vm._v("Feltet må fylles ut")])])]),_c('div',{staticClass:"control is-grouped Form-control"},[_c('p',{staticClass:"control is-expanded Form-control"},[_c('label',{staticClass:"label",attrs:{"for":"email"}},[_vm._v("E-post")]),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"input is-large",class:{'is-danger': _vm.errors.has('Epost')},attrs:{"id":"email","name":"Epost","type":"email"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Epost')),expression:"errors.has('Epost')"}],staticClass:"form-error"},[_vm._v(_vm._s(_vm.errors.first('Epost')))])]),_c('p',{staticClass:"control Form-control"},[_c('label',{staticClass:"label"},[_vm._v("Telefon")]),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",class:{'is-danger': _vm.errors.has('Telefon')},attrs:{"name":"Telefon","type":"tel"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('Telefon')),expression:"errors.has('Telefon')"}],staticClass:"form-error"},[_vm._v("Feltet må fylles ut")])]),_c('p',{staticClass:"control Form-control"},[_c('label',{staticClass:"label",staticStyle:{"display":"inline-block"},attrs:{"for":"dob"}},[_vm._v("Fødselsdato")]),_vm._m(2),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"input is-large",class:{'is-danger': _vm.errors.has('dob')},attrs:{"name":"dob","placeholder":"dag.måned.år","type":"text"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('dob')),expression:"errors.has('dob')"}],staticClass:"form-error"},[_vm._v("Feltet må fylles ut")])])]),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button Button is-primary is-marginless send-button",class:{'is-loading': _vm.isLoading},attrs:{"type":"button"},on:{"click":_vm.validateForm}},[_vm._v("Send")])])])]),_vm._m(3)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"Article-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column",staticStyle:{"background":"url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAHElEQVQYV2N8buL2X/LMLkYGKIAzMARgKjFUAABX/QgF18z6NgAAAABJRU5ErkJggg==')"}},[_c('div',{staticClass:"Article-headerBackground"},[_c('h1',[_vm._v("Bli"),_c('br'),_vm._v("medlem i Rød Ungdom!")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"hidden"},[_c('label',{staticClass:"label"},[_vm._v("Bot field")]),_c('input',{attrs:{"name":"bot-field"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('small',[_vm._v("  (dd.mm.åååå)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-5-widescreen is-offset-0-widescreen is-10-tablet is-offset-1-tablet Infobox-container"},[_c('aside',{staticClass:"InfoBox has-padding"},[_c('div',{staticClass:"content"},[_c('h4',[_vm._v("Hvor mye skal du betale?")]),_c('p',[_vm._v("Kontingentsatsene er som følger:"),_c('br'),_vm._v("Førstegangskontingent: 50 kr."),_c('br'),_vm._v("Ungdomsskoleelever/arbeidsløse: 100 kr."),_c('br'),_vm._v("Videregåendeelever/studenter/vernepliktige: 200 kr."),_c('br'),_vm._v("Arbeidende: 400 kr.")]),_c('h4',[_vm._v("Hvordan betaler du?")]),_c('p',[_vm._v("Du kan betale på tre ulike måter:"),_c('br'),_c('br'),_vm._v("1. Overføring i nettbank til kontonummer: 1645.13.32663. Det er denne måten vi liker best, fordi da får vi hele summen selv! Husk å merke betalingen med navn."),_c('br'),_c('br'),_vm._v("2. Vipps: Trykk på \"Kjøp noe\" i appen, søk opp \"Kontingent Rød Ungdom\" eller 120248 og vipps kontingentsummen. Husk å merke betalingen med navn. OBS! Ikke bruk kontoen \"Rød Ungdom\", bruk \"Kontingent Rød Ungdom\"."),_c('br'),_c('br'),_c('em',[_vm._v("Vi gjentar: Uansett hvilken metode du velger, så må du huske å merke betalingen med ditt navn!")])])])])])}]


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"margin-bottom":"0px"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"Issues"},[_c('div',{staticClass:"columns Issues-container is-multiline",style:({ marginBottom: 44 + 'px', display: 'flex' })},_vm._l((_vm.issues),function(issue){return _c('issue-card',{key:issue.id,attrs:{"issue":issue}})}))])])])}
var staticRenderFns = []


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ArticleList"},[_c('div',{staticClass:"container"},[_c('h3',{staticClass:"title sectionHeading is-padded"},[_vm._v("Siste nytt")]),_vm._v(" "),_c('transition-group',{staticClass:"columns is-multiline",attrs:{"name":"fade","tag":"div","id":"ArticleContainer","itemscope":"","itemtype":"http://schema.org/ItemList"}},_vm._l((_vm.newsItems),function(newsItem){return _c('news-item',{key:newsItem.title,attrs:{"title":newsItem.title,"image":newsItem.thumbnail,"lead":newsItem.lead,"slug":_vm.generateSlug(newsItem.slug.current)}})})),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-clearfix ArticleList-buttonContainer"},[_c('button',{staticClass:"button Button is-pink",class:{ 'is-loading': _vm.isLoading},attrs:{"type":"button","name":"button"},on:{"click":_vm.loadMoreArticles}},[_c('span',[_vm._v("Hent flere artikler")])])])])],1)])}
var staticRenderFns = []


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.article)?_c('loader'):_c('article',{staticClass:"Article"},[_c('header',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-8 is-offset-2 is-7-widescreen"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.article.title))]),_c('p',{staticClass:"lead-in",staticStyle:{"margin-bottom":"44px"}},[_vm._v(_vm._s(_vm.article.lead))])])]),(_vm.article.headerImage)?_c('div',{staticClass:"column is-10 is-offset-1"},[_c('image-source',{attrs:{"alt":_vm.article.headerImage.caption,"ratio":1.78,"source":_vm.article.headerImage.asset.url,"widths":_vm.mediumWidths}})],1):_vm._e()])]),(_vm.article.blocks)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-multiline"},[_c('block-render',{attrs:{"blocks":_vm.article.blocks.content,"textWrapClasses":'column is-8 is-7-widescreen is-offset-2'}})],1)]):_vm._e(),(_vm.article.factbox)?_c('section',{staticStyle:{"margin-bottom":"0"}},[(_vm.article.factbox.content)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-9 is-offset-1"},[_c('div',{staticClass:"InfoBox"},[_c('div',{staticClass:"content"},[_c('block-render',{attrs:{"blocks":_vm.article.factbox.content}})],1)])])])]):_vm._e()]):_vm._e(),_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7 is-offset-2"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-clearfix"},[_c('a',{staticClass:"is-pulled-right Button is-outline is-font-sans Sharebutton",attrs:{"href":_vm.shareUrl}},[_vm._v("Del på Facebook")])])])])])])]),(_vm.relatedIssues)?_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7 is-offset-2"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("Les mer om lignende saker")]),_vm._l((_vm.relatedIssues),function(relatedIssue){return _c('div',{staticClass:"IssueList-item"},[_c('a',{attrs:{"href":_vm.getSlug(relatedIssue)}},[_vm._v(_vm._s(relatedIssue.title))])])})],2)])])])]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Campaign is-medium"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-7-widescreen is-offset-4-widescreen is-8-tablet is-offset-4-tablet"},[_c('div',{ref:"imageContainer",staticClass:"Campaign-image"},[(_vm.width)?_c('image-source',{attrs:{"alt":_vm.text,"ratio":1.78,"source":_vm.imageUrl,"width":_vm.width,"widths":_vm.widths}}):_vm._e()],1),_c('div',{staticClass:"Campaign-textBoxShadow"}),_c('div',{staticClass:"Campaign-textBox"},[_c('router-link',{attrs:{"to":_vm.link}},[_c('div',{staticClass:"Campaign-content"},[_c('h2',{staticClass:"Campaign-heading title"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"Campaign-readMore trailingarrow"},[_vm._v(_vm._s(_vm.ctaText))])])])],1)])])])])}
var staticRenderFns = []


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{class:_vm.wrapClasses},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"Document"},[_c('div',{staticClass:"Document-icon"},[_c('icon',{attrs:{"name":"file-text-o"}})],1),_vm._v(" "),_c('div',{staticClass:"Document-text"},[(_vm.document.file || _vm.document.url)?_c('div',[_c('a',{attrs:{"href":_vm.document.url || _vm.document.file.asset,"target":"_blank"}},[_c('h4',[_vm._v(_vm._s(_vm.document.title))])]),_vm._v(" "),_c('p',{staticClass:"Document-description"},[_vm._v(_vm._s(_vm.document.description))])]):_c('h4',[_vm._v("Dokumentet er slettet")])])])])])])}
var staticRenderFns = []


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"LokallagFinder"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-8-widescreen is-offset-2-widescreen is-10-tablet is-offset-1-tablet"},[_c('div',{staticClass:"LokallagFinderBox"},[_c('h3',{staticClass:"LokallagFinder-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"Lokallagsdropdown"},[_c('button',{staticClass:"Button LokallagFinder-button",on:{"click":_vm.toggleDropdown}},[_vm._v("\n              Finn ditt lokallag\n              "),_c('icon',{attrs:{"name":"chevron-down"}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"LokallagFinder-dropdownContent"},[_c('ul',_vm._l((_vm.chapters),function(chapter){return _c('li',[_c('a',{staticClass:"LokallagFinder-link",class:chapter.county ? 'Ikke-fylke' : 'Fylke',attrs:{"href":chapter.slug.current}},[_vm._v("\n                      "+_vm._s(chapter.title)+"\n                    ")])])}))])])],1)])])])])])}
var staticRenderFns = []


/***/ }),
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, exports) {

module.exports = {"stripeKey":"pk_test_IAteMFQFpBFhPz7r1Jqg4oGT","stripeOptions":{"elements":{"locale":"no","fonts":[{"family":"Roboto Mono","src":"url(\"data:font/ttf;base64,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\") format(\"truetype\")","style":"normal","weight":"normal"}]},"hidePostalCode":true,"iconStyle":"solid","style":{"base":{"iconColor":"#cecece","color":"black","lineHeight":"36px","fontSize":"14px","fontWeight":300,"fontFamily":"'Roboto Mono', 'Helvetica Neue', Helvetica, sans-serif","::placeholder":{"color":"#cecece"}},"invalid":{"iconColor":"#e85746","color":"#e85746"}},"classes":{"focus":"is-focused","empty":"is-empty"}}}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 512 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[285]);


// WEBPACK FOOTER //
// static/js/app.3551704a47194d2412d6.js